import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import { useTheme, alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import "../../css/EstimatesStyles.css";
import { DataGridPro, GridToolbar, useGridApiRef } from "@mui/x-data-grid-pro";

import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  Stack,
  Chip,
  Badge,
  useMediaQuery,
  Dialog,
  DialogContent,
  CircularProgress,
  Backdrop,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import { useContestacionAvisos } from "./useContestacionAvisos";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import ExcelIcon from "../../img/Icons/excel50.png"; // ruta a tu SVG

import axios from "axios";

import "jspdf-autotable";

import {
  getFileContent,
  invalidatePresupuestoFilesCache,
} from "../../api/Proyectos/projectFilesApi";
import FileThumbnailsEstimates from "./FileThumbnailsEstimates";

import BudgetPrintSelectionAgrupado from "./BudgetPrintSelectionAgrupado";

import * as XLSX from "xlsx";
import { Add } from "@mui/icons-material";

import { ChevronRight, ExpandMore } from "@mui/icons-material";

import { SidebarContext } from "../Sidebar/SidebarProvider";
import { getAllProyectosConPresupuestos } from "../../api/Proyectos/proyectoApi";
import { getProductosYMuestras } from "../../api/Muestras/productosYMuestrasApi";
import { getModelosTipo } from "../../api/Design/modelosTipoApi";
import { getTemporadas } from "../../api/Temporadas/temporadaApi";
import { getClientes } from "../../api/Customer/customerApi";
import {
  compareEstimateTreeRows,
  getEstimateTreeDataPath,
  getEstimateTreeGroupHeader,
} from "./estimateSeasonSort";
import { estimateMatchesSearchTerm } from "../../utils/estimateSearchUtils";

import { fetchAllBudgetLines } from "../../api/Estimates/budgetLinesApi"; // añadir si no está
import {
  getEstimatesCommsSummary,
  isTommyClient,
  markPresupuestoOffered,
} from "../../api/Estimates/estimateRfqApi";

import BudgetPrintSelection from "./BudgetPrintSelection";
import EstimateEnviarOfertaConjuntaDialog from "./EstimateEnviarOfertaConjuntaDialog";
import EstimateTommyOfferedDialog from "./EstimateTommyOfferedDialog";
import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";

import {
  getEscandalloGrupos,
  getEscandalloSubgruposMuestras,
} from "../../api/Muestras/muestraApi";

// import { getFileContent } from "../../api/Proyectos/projectFilesApi"; // (no usado aquí)

import NewBudgetDrawer from "./NewBudgetDrawer";

import {
  colorForDesign,
  designChipSx,
  statusChipSx,
  statusDateChipSx,
  treeGroupChipSx,
  STATUS_CHIP_COLORS,
} from "../../utils/estimatesDesignUtils";
import {
  budgetMatchesPhotoSearch,
  fileToSearchBase64Resized,
  getBudgetPhotoSearchScore,
  pickEstimateGridThumbnailFile,
  resolvePhotoSearchScores,
} from "../../utils/imageSearchUtils";
import { searchEstimateImageHits } from "../../api/AI/aiSearchApi";
import {
  resolvePresupuestoProductIdentity,
  findCatalogItem,
} from "../../utils/newBudgetDrawerUtils";
import {
  pageHeroShellSx,
  pageFieldSx,
  pageContentCardSx,
  pageKpiChipSx,
  pageMobileCardSx,
  pageSectionTitleSx,
} from "../../styles/pageModernStyles";
import EntityAvatar from "../CriticalPathHorizontal/EntityAvatar";
import { getSupplierColor } from "../CriticalPathHorizontal/criticalPathAvatars";

import { useSearchParams } from "react-router-dom"; // 🟢 ya que lo usarás

export const linesCache = new Map(); // fuera del componente

// 🧠 Cache global para evitar descargas repetidas
export const budgetImagesCache = new Map();

const IMAGE_FETCH_CONCURRENCY = 4;

async function mapWithConcurrency(items, limit, mapper) {
  if (!items.length) return [];
  const results = new Array(items.length);
  let cursor = 0;

  const worker = async () => {
    while (cursor < items.length) {
      const index = cursor;
      cursor += 1;
      results[index] = await mapper(items[index], index);
    }
  };

  await Promise.all(
    Array.from({ length: Math.min(limit, items.length) }, () => worker()),
  );
  return results;
}

const BudgetListThumbnail = React.memo(
  ({ budget, file, onRequest, lazy = false, enablePreview = false }) => {
    const containerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(!lazy);
    const [previewOpen, setPreviewOpen] = useState(false);

    useEffect(() => {
      if (!lazy || isVisible) return undefined;
      const node = containerRef.current;
      if (!node || typeof IntersectionObserver === "undefined") {
        setIsVisible(true);
        return undefined;
      }
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        { rootMargin: "120px 0px" },
      );
      observer.observe(node);
      return () => observer.disconnect();
    }, [lazy, isVisible]);

    useEffect(() => {
      if (!isVisible || file !== undefined || !budget?.IdPresupuesto) return;
      onRequest(budget);
    }, [isVisible, file, budget, onRequest]);

    const isImage = Boolean(file?.mimeType?.includes("image") && file?.data);
    const imgSrc = isImage ? `data:${file.mimeType};base64,${file.data}` : null;
    const previewTitle =
      file?.fileName ||
      budget?.DiseñoMuestra ||
      budget?.designCliente ||
      "Article image";

    const handlePreviewOpen = (event) => {
      if (!enablePreview || !isImage) return;
      event.stopPropagation();
      event.preventDefault();
      setPreviewOpen(true);
    };

    const thumbBoxSx = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      minHeight: lazy ? 88 : undefined,
      cursor: enablePreview && isImage ? "zoom-in" : "default",
    };

    return (
      <Box ref={containerRef} sx={thumbBoxSx}>
        {file === undefined ? (
          <Typography variant="caption" color="text.disabled">
            …
          </Typography>
        ) : file ? (
          isImage && enablePreview ? (
            <>
              <Box
                component="img"
                data-article-thumb="true"
                src={imgSrc}
                alt={previewTitle}
                onClick={handlePreviewOpen}
                sx={{
                  maxWidth: "100%",
                  maxHeight: lazy ? 84 : 56,
                  width: "auto",
                  objectFit: "contain",
                  borderRadius: 1.25,
                  border: "1px solid",
                  borderColor: "divider",
                  bgcolor: "background.paper",
                  boxShadow: 1,
                  transition: "transform 0.15s ease, box-shadow 0.15s ease",
                  "&:hover": {
                    transform: "scale(1.04)",
                    boxShadow: 3,
                  },
                }}
              />
              <Dialog
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                maxWidth="lg"
                fullWidth
                onClick={(e) => e.stopPropagation()}
                PaperProps={{
                  sx: {
                    borderRadius: 3,
                    overflow: "hidden",
                    bgcolor: "background.paper",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 2,
                    py: 1.25,
                    borderBottom: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 800 }}
                    noWrap
                  >
                    {previewTitle}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => setPreviewOpen(false)}
                    aria-label="Close preview"
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>
                <DialogContent
                  sx={{
                    p: { xs: 1.5, sm: 2 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: (t) => alpha(t.palette.common.black, 0.03),
                  }}
                >
                  <Box
                    component="img"
                    src={imgSrc}
                    alt={previewTitle}
                    sx={{
                      maxWidth: "100%",
                      maxHeight: { xs: "62vh", md: "78vh" },
                      objectFit: "contain",
                      borderRadius: 2,
                    }}
                  />
                </DialogContent>
              </Dialog>
            </>
          ) : (
            <FileThumbnailsEstimates
              filePath={file}
              onDelete={null}
              showDelete={false}
            />
          )
        ) : (
          <Typography
            component="span"
            variant="caption"
            color="text.disabled"
            sx={lazy ? undefined : { color: "#aaa" }}
          >
            —
          </Typography>
        )}
      </Box>
    );
  },
);

/* GUARDAR LAS CHECK BOX */

const getUserIdFromToken = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return "anonymous";

    const decoded = jwtDecode(token);
    return decoded.userId; // 👈 EXACTO según tu backend
  } catch (e) {
    console.error("Error decoding token for column prefs", e);
    return "anonymous";
  }
};
/* GUARDAR LAS CHECK BOX */

const Estimates = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();
  const navigate = useNavigate();
  /* const { isMinimized } = useContext(SidebarContext);
  const marginLeft = isMinimized ? "4em" : "15em"; */

  const { contentMargin } = useContext(SidebarContext);

  const { count: contestacionAvisosCount } = useContestacionAvisos();
  const [proyectos, setProyectos] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedBudget, setSelectedBudget] = useState(null);
  const [escandalloGrupos, setEscandalloGrupos] = useState([]);
  const [escandalloSubgrupos, setEscandalloSubgrupos] = useState([]);
  const [linesForSelectedBudget, setLinesForSelectedBudget] = useState([]);

  const [productosYMuestras, setProductosYMuestras] = useState([]);
  const [modelosTipo, setModelosTipo] = useState([]);

  const [incoterms, setIncoterms] = useState([]);
  const [temporadas, setTemporadas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const photoSearchInputRef = useRef(null);
  const [photoSearchLoading, setPhotoSearchLoading] = useState(false);
  const [photoSearchCandidateCount, setPhotoSearchCandidateCount] = useState(0);
  const [photoSearchScores, setPhotoSearchScores] = useState(null);
  const [photoSearchPreview, setPhotoSearchPreview] = useState(null);
  const [photoSearchDragging, setPhotoSearchDragging] = useState(false);

  const createBudgetRef = useRef(null); // para disparar la creación desde el padre
  const [canCreate, setCanCreate] = useState(false);
  const [missingKeys, setMissingKeys] = useState([]);

  const apiRef = useGridApiRef();
  const [expandedIds, setExpandedIds] = React.useState(() => new Set());

  /* GUARDAR LAS CHECK BOX */

  const userId = getUserIdFromToken();

  const COLUMN_VISIBILITY_KEY = `estimates-column-visibility:user:${userId}`;
  const TREE_GROUP_MODE_KEY = `estimates-tree-group-mode:user:${userId}`;
  const DEFAULT_COLUMN_VISIBILITY = {
    FechaCrear: false,
    FechaPresentacion: false,
    FechaCancelacion: false,
    FechaAceptacion: false,
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => {
    const saved = localStorage.getItem(COLUMN_VISIBILITY_KEY);
    return saved
      ? { ...DEFAULT_COLUMN_VISIBILITY, ...JSON.parse(saved) }
      : DEFAULT_COLUMN_VISIBILITY;
  });

  const [treeGroupMode, setTreeGroupMode] = useState(() => {
    const saved = localStorage.getItem(TREE_GROUP_MODE_KEY);
    return saved === "season" ? "season" : "client";
  });

  useEffect(() => {
    localStorage.setItem(
      COLUMN_VISIBILITY_KEY,
      JSON.stringify(columnVisibilityModel),
    );
  }, [COLUMN_VISIBILITY_KEY, columnVisibilityModel]);

  useEffect(() => {
    localStorage.setItem(TREE_GROUP_MODE_KEY, treeGroupMode);
  }, [TREE_GROUP_MODE_KEY, treeGroupMode]);

  const handleTreeGroupModeChange = (_event, next) => {
    if (!next || next === treeGroupMode) return;
    setTreeGroupMode(next);
    setExpandedIds(new Set());
    localStorage.setItem("expandedIds", "[]");
  };

  const resetUserColumns = () => {
    localStorage.removeItem(COLUMN_VISIBILITY_KEY);
    setColumnVisibilityModel(DEFAULT_COLUMN_VISIBILITY);
  };

  /* GUARDAR LAS CHECK BOX */

  // 🧠 Recuperar expansión guardada al iniciar
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("expandedIds") || "[]");
    if (saved.length > 0) {
      setExpandedIds(new Set(saved));
    }
  }, []);

  // 💾 Guardar expansión cada vez que cambia
  useEffect(() => {
    localStorage.setItem("expandedIds", JSON.stringify([...expandedIds]));
  }, [expandedIds]);

  const handleValidate = useCallback((ok, missing) => {
    setCanCreate(ok);
    setMissingKeys(missing || []);
  }, []);

  /* const [thumbs, setThumbs] = useState({}); */ // { [NumeroPresupuesto|IdPresupuesto]: url }

  // Imagenes
  const [budgetImages, setBudgetImages] = useState({});
  const budgetImagesAttemptedRef = useRef(new Set());
  const budgetImagesRef = useRef(budgetImages);
  const imageQueueRef = useRef([]);
  const imageQueueRunningRef = useRef(false);

  useEffect(() => {
    budgetImagesRef.current = budgetImages;
  }, [budgetImages]);

  const statusColors = STATUS_CHIP_COLORS;

  const getStatusDateMeta = (budget) => {
    const status = budget?.PresupuestoEstado;
    const milestonesByStatus = {
      Accepted: ["Accepted", budget?.FechaAceptacion],
      Cancelled: ["Cancelled", budget?.FechaCancelacion],
      Offered: ["Offered", budget?.FechaPresentacion],
      Created: ["Created", budget?.FechaCrear],
    };

    const fallbackMilestones = [
      ["Accepted", budget?.FechaAceptacion],
      ["Cancelled", budget?.FechaCancelacion],
      ["Offered", budget?.FechaPresentacion],
      ["Created", budget?.FechaCrear],
    ];

    const [milestoneLabel, rawDate] = milestonesByStatus[status] ||
      fallbackMilestones.find(([, value]) => Boolean(value)) || [
        "Created",
        null,
      ];

    const parsed = rawDate ? Date.parse(rawDate) : NaN;

    return {
      StatusDate: rawDate || "-",
      StatusMilestone: milestoneLabel,
      StatusDateSort: Number.isNaN(parsed) ? 0 : parsed,
    };
  };

  const [originalData, setOriginalData] = useState([]); // 🔹 Guardamos la data original
  const [expandedGroups, setExpandedGroups] = useState(null);

  // 🔹 Carga dinámica de imágenes al expandir grupos/proyectos

  const flushImageQueue = useCallback(async () => {
    if (imageQueueRunningRef.current) return;
    imageQueueRunningRef.current = true;
    try {
      while (imageQueueRef.current.length > 0) {
        const batch = imageQueueRef.current.splice(0, IMAGE_FETCH_CONCURRENCY);
        const results = await Promise.all(
          batch.map(async (b) => {
            try {
              const files = await getFileContent(
                b.NumeroPresupuesto || b.IdPresupuesto,
              );
              const imgFile = pickEstimateGridThumbnailFile(files);
              budgetImagesCache.set(b.IdPresupuesto, imgFile);
              return { id: b.IdPresupuesto, img: imgFile };
            } catch {
              budgetImagesCache.set(b.IdPresupuesto, null);
              return { id: b.IdPresupuesto, img: null };
            }
          }),
        );

        const updates = results.reduce((acc, r) => {
          if (r?.id) acc[r.id] = r.img ?? null;
          return acc;
        }, {});

        if (Object.keys(updates).length > 0) {
          setBudgetImages((prev) => ({ ...prev, ...updates }));
        }
      }
    } finally {
      imageQueueRunningRef.current = false;
    }
  }, []);

  const requestBudgetImage = useCallback(
    (budget) => {
      const id = budget?.IdPresupuesto;
      if (!id) return;

      if (budgetImagesCache.has(id)) {
        if (budgetImagesRef.current[id] === undefined) {
          setBudgetImages((prev) => ({
            ...prev,
            [id]: budgetImagesCache.get(id),
          }));
        }
        return;
      }

      if (budgetImagesAttemptedRef.current.has(id)) return;
      budgetImagesAttemptedRef.current.add(id);

      if (!imageQueueRef.current.some((b) => b.IdPresupuesto === id)) {
        imageQueueRef.current.push(budget);
      }
      flushImageQueue();
    },
    [flushImageQueue],
  );

  const fetchBudgetImagesForGroup = useCallback(
    async (groupId) => {
      const normalizedGroupId = String(groupId || "")
        .replace(/\s\(\d+\)$/, "")
        .trim();
      if (!normalizedGroupId) return;

      const groupBudgets = proyectos.filter(
        (p) =>
          p.TemporadaNombre === normalizedGroupId ||
          p.ClienteNombre === normalizedGroupId ||
          p.ProyectoNombre === normalizedGroupId,
      );

      const pendientes = groupBudgets.filter(
        (b) =>
          b.IdPresupuesto &&
          !budgetImagesAttemptedRef.current.has(b.IdPresupuesto),
      );
      if (pendientes.length === 0) return;

      const cachedUpdates = {};
      pendientes.forEach((b) => {
        if (budgetImagesCache.has(b.IdPresupuesto)) {
          budgetImagesAttemptedRef.current.add(b.IdPresupuesto);
          cachedUpdates[b.IdPresupuesto] = budgetImagesCache.get(
            b.IdPresupuesto,
          );
        }
      });
      if (Object.keys(cachedUpdates).length > 0) {
        setBudgetImages((prev) => ({ ...prev, ...cachedUpdates }));
      }

      const toFetch = pendientes.filter(
        (b) => !budgetImagesCache.has(b.IdPresupuesto),
      );
      if (toFetch.length === 0) return;

      toFetch.forEach((b) =>
        budgetImagesAttemptedRef.current.add(b.IdPresupuesto),
      );

      const results = await mapWithConcurrency(
        toFetch,
        IMAGE_FETCH_CONCURRENCY,
        async (b) => {
          try {
            const files = await getFileContent(
              b.NumeroPresupuesto || b.IdPresupuesto,
            );
            const imgFile = pickEstimateGridThumbnailFile(files);
            budgetImagesCache.set(b.IdPresupuesto, imgFile);
            return { id: b.IdPresupuesto, img: imgFile };
          } catch {
            budgetImagesCache.set(b.IdPresupuesto, null);
            return { id: b.IdPresupuesto, img: null };
          }
        },
      );

      const nuevos = results.reduce((acc, r) => {
        if (r?.id) acc[r.id] = r.img ?? null;
        return acc;
      }, {});

      if (Object.keys(nuevos).length > 0) {
        setBudgetImages((prev) => ({ ...prev, ...nuevos }));
      }
    },
    [proyectos],
  );

  /* Imrpimir multiples presupuestos */
  const [selectedBudgets, setSelectedBudgets] = useState([]);
  const [batchOfferOpen, setBatchOfferOpen] = useState(false);
  const [tommyBatchOpen, setTommyBatchOpen] = useState(false);
  const [tommyBatchConfirming, setTommyBatchConfirming] = useState(false);

  const selectedLeafBudgets = React.useMemo(() => {
    const ids = (Array.isArray(selectedBudgets) ? selectedBudgets : [])
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id) && id > 0);
    const byId = new Map(
      (proyectos || []).map((p) => [Number(p.IdPresupuesto), p]),
    );
    const out = [];
    const seen = new Set();
    for (const id of ids) {
      if (seen.has(id)) continue;
      const row = byId.get(id);
      if (!row) continue;
      seen.add(id);
      out.push(row);
    }
    return out;
  }, [selectedBudgets, proyectos]);

  const batchOfferReady =
    selectedLeafBudgets.length >= 2 && selectedLeafBudgets.length <= 20;

  const tommyBatchItems = React.useMemo(() => {
    if (!batchOfferReady) return [];
    return selectedLeafBudgets.filter((p) =>
      isTommyClient({
        idCliente: p.IdCliente,
        clienteNombre: p.ClienteNombre,
      }),
    );
  }, [batchOfferReady, selectedLeafBudgets]);

  const isTommyBatchSelection =
    batchOfferReady && tommyBatchItems.length === selectedLeafBudgets.length;

  const openBatchOfferFlow = () => {
    if (isTommyBatchSelection) {
      setTommyBatchOpen(true);
      return;
    }
    setBatchOfferOpen(true);
  };

  const confirmTommyBatchOffered = async () => {
    const toMark = selectedLeafBudgets.filter(
      (p) => String(p.Estado || "") === "Created",
    );
    setTommyBatchConfirming(true);
    try {
      for (const p of toMark) {
        await markPresupuestoOffered(p.IdPresupuesto);
      }
      setTommyBatchOpen(false);
      setSelectedBudgets([]);
      await fetchBudgets(incoterms);
    } catch (err) {
      console.error("Error marcando Tommy como Offered:", err);
      alert(
        err?.response?.data?.error ||
          err?.message ||
          "No se pudieron marcar como Offered",
      );
    } finally {
      setTommyBatchConfirming(false);
    }
  };

  // ====== fetchBudgets ARRIBA para evitar TDZ ======

  const fetchBudgets = useCallback(
    async (incotermsList = []) => {
      try {
        const [proyectosData, allLinesData, commsSummary] = await Promise.all([
          getAllProyectosConPresupuestos(),
          fetchAllBudgetLines(),
          getEstimatesCommsSummary().catch(() => []),
        ]);

        const commsByPresupuesto = new Map(
          (Array.isArray(commsSummary) ? commsSummary : []).map((row) => [
            Number(row.IdPresupuesto),
            {
              CommCount: Number(row.CommCount) || 0,
              ClientOfferCount: Number(row.ClientOfferCount) || 0,
              RfqCount: Number(row.RfqCount) || 0,
              OpenRfqCount: Number(row.OpenRfqCount) || 0,
              LastCommAt: row.LastCommAt || null,
              HasComms:
                (Number(row.CommCount) || 0) > 0 ||
                (Number(row.ClientOfferCount) || 0) > 0 ||
                (Number(row.RfqCount) || 0) > 0,
            },
          ]),
        );

        // Guardamos líneas en cache global
        Object.entries(allLinesData).forEach(([idPresupuesto, lines]) => {
          linesCache.set(Number(idPresupuesto), lines);
        });

        setOriginalData(proyectosData);

        const withDesignColor = proyectosData.map((item) => {
          const nombreDiseño =
            String(item.DiseñoMuestra || "").trim() ||
            String(item.designCliente || "").trim() ||
            "";
          const matchedItem = findCatalogItem(productosYMuestras, {
            idProducto: item.IdProducto,
            idMuestra: item.IdMuestra,
            nombre: nombreDiseño || undefined,
          });
          const diseñoMuestra =
            matchedItem?.Nombre ||
            item.DiseñoMuestra ||
            item.designCliente ||
            "-";
          const identity = resolvePresupuestoProductIdentity(
            {
              ...item,
              DiseñoMuestra:
                diseñoMuestra === "-" ? nombreDiseño : diseñoMuestra,
            },
            productosYMuestras,
            modelosTipo,
          );
          const incotermMatch = incotermsList.find(
            (i) => Number(i.Id_Incoterm) === Number(item.Id_Incoterm),
          );

          return {
            ...item,
            DiseñoMuestra: diseñoMuestra,
            TipoPrenda: identity.TipoPrenda || item.TipoPrenda || null,
            ABREVIATURA: identity.ABREVIATURA || item.ABREVIATURA || null,
            VOL: identity.VOL ?? item.VOL ?? null,
            colorGroup: colorForDesign(diseñoMuestra),
            IncotermNombre: incotermMatch?.Incoterm || "",
          };
        });

        const presupuestosConTotales = withDesignColor.map((presupuesto) => {
          const lines = linesCache.get(presupuesto.IdPresupuesto) || [];
          const units = Number(presupuesto.Units || 0);
          const isDDP = Number(presupuesto.Id_Incoterm) === 4;

          const n = (v) => {
            const t = typeof v === "string" ? v.replace(",", ".") : v;
            const x = Number(t);
            return Number.isFinite(x) ? x : 0;
          };

          const PERCENT_IDS = new Set([192, 209, 210]);
          const PER_SHIPMENT_IMPORT_IDS = new Set([205, 206, 193, 208]);

          const unitCostExact = (line) => {
            const base = n(line.Coste) * n(line.Un) * (n(line.TipoCambio) || 1);
            return PERCENT_IDS.has(Number(line.ESCANDALLO_SUBGRUPO))
              ? base / 100
              : base;
          };

          const unitSaleExact = (line) => {
            const c = unitCostExact(line);
            const m = n(line.MargenVenta ?? 10);
            const denom = 1 - m / 100;
            return denom !== 0 ? c / denom : n(line.Venta) || 0;
          };

          const totalCost = lines.reduce((acc, line) => {
            const isImport = line.ESCANDALLO_GRUPOS === 13;
            const sg = Number(line.ESCANDALLO_SUBGRUPO);
            const cUnit = unitCostExact(line);

            if (!isDDP) return acc + (isImport ? cUnit : cUnit * units);
            if (!isImport) return acc + cUnit * units;
            if (PER_SHIPMENT_IMPORT_IDS.has(sg)) return acc + cUnit;
            return acc + cUnit * units;
          }, 0);

          const totalVenta = lines.reduce((acc, line) => {
            const isImport = line.ESCANDALLO_GRUPOS === 13;
            const sg = Number(line.ESCANDALLO_SUBGRUPO);
            const sUnit = unitSaleExact(line);

            if (!isDDP) return acc + (isImport ? sUnit : sUnit * units);
            if (!isImport) return acc + sUnit * units;
            if (PER_SHIPMENT_IMPORT_IDS.has(sg)) return acc + sUnit;
            return acc + sUnit * units;
          }, 0);

          const margenTotal = totalVenta - totalCost;
          const margenPct = totalVenta ? (margenTotal / totalVenta) * 100 : 0;
          const costeUnitario = units ? totalCost / units : 0;
          const ventaUnitaria = units ? totalVenta / units : 0;
          const margenUnitario = ventaUnitaria - costeUnitario;
          const monedaVenta =
            lines.find((l) => String(l?.MonedaVenta || "").trim())
              ?.MonedaVenta || null;
          const statusDateMeta = getStatusDateMeta(presupuesto);
          const commMeta = commsByPresupuesto.get(
            Number(presupuesto.IdPresupuesto),
          ) || {
            CommCount: 0,
            ClientOfferCount: 0,
            RfqCount: 0,
            OpenRfqCount: 0,
            LastCommAt: null,
            HasComms: false,
          };

          return {
            ...presupuesto,
            ...statusDateMeta,
            ...commMeta,
            CosteConvertido: Number(totalCost.toFixed(2)),
            Venta: Number(totalVenta.toFixed(2)),
            Margen: Number(margenPct.toFixed(2)),
            UnitsUnitario: units,
            CosteUnitario: Number(costeUnitario.toFixed(2)),
            VentaUnitaria: Number(ventaUnitaria.toFixed(2)),
            MargenUnitario: Number(margenUnitario.toFixed(2)),
            MonedaVenta: monedaVenta || presupuesto.MonedaVenta || null,
            id: presupuesto.IdPresupuesto,
          };
        });

        // Temporada (año desc + estación) → Cliente → Proyecto → Diseño
        presupuestosConTotales.sort((a, b) =>
          compareEstimateTreeRows(a, b, temporadas),
        );

        setProyectos(presupuestosConTotales);

        const initialExpandedState = proyectosData.reduce((acc, item) => {
          acc[item.ProyectoNombre] = true;
          return acc;
        }, {});
        setExpandedGroups(initialExpandedState);
        return presupuestosConTotales;
      } catch (err) {
        console.error("❌ Error en fetchBudgets:", err);
        return [];
      }
    },
    [productosYMuestras, modelosTipo, temporadas, clientes],
  );

  const handleBudgetAdded = useCallback(
    async (focusBudget) => {
      const rows = await fetchBudgets(incoterms);
      const focusId = focusBudget?.IdPresupuesto;
      if (!focusId) return;

      const found = (Array.isArray(rows) ? rows : []).find(
        (row) => String(row.IdPresupuesto) === String(focusId),
      );
      const next = found || {
        ...focusBudget,
        IdPresupuesto: focusId,
        id: focusId,
        PresupuestoEstado:
          focusBudget.PresupuestoEstado || focusBudget.Estado || "Created",
      };
      setSelectedBudget(next);
      setSelectedId(next.IdPresupuesto);
    },
    [fetchBudgets, incoterms],
  );

  // Logo Claro
  const logoStage =
    "iVBORw0KGgoAAAANSUhEUgAAARAAAAEQCAYAAAB4CisVAAAACXBIWXMAAC4jAAAuIwF4pT92AAAcoUlEQVR4nO2d4XXbONeEB3vyf50KXrqCOBWsUkGSCqJUEG8F663ASQVyKrC3AnErsFOBuBXYXwXz/QBoQRQpURRJAOQ85/iYtCgJlsjh3IsLwEDMBpILb3dRefh3AFctXuYFwK/K3wr3AwCFMaaAmAUmdANEP5C8gBWAzP38z9vOwrQKufv9BOD/3P6LMeYpUHtEz0hAEoTkFaxYvHO/rwBcBG3U6TzBupZfsMIi55IgEpDIIZnBCsQf7vei40vl7nc1BCmwDT9OxRcuPwTK0M31vMC28xeA3BiTd2yXGAkJSGQ4wVjACsYC7S/Ewv386/ZzBA4XvLCq/F2GVYsTXiaH/Z8kKBEiAYkAkp+wFYw2icwcNgT4BWv986HaNhROKDPY/7kMxbIWT32AFZQHhTzhkYAEwN2ZPwH4CHsBHcpfFNi19ZNNQLrPZYFtyLY48pQCVlB+TvlzEQIkL0guSd7zMM8kV+7YLHS7Q0NyQfKG5PrI57YheesSzEJMA5KfnCAc4tFdJDr5D+BEuPw8N0fE5EYCLJKEZObuhodO8nvKZZwFyasWn/Oa5DJ0W4U4ihOE9bGTmTbWFz3SQkye3eNZ6LYK8Qqtrb45cOJuSF7rxB0P2rzJyolGk5AvQrdTzBjaMKXpJC0TocppBITbxPXjAXFfhm6nmBGecBxyGwpRIoM2xDn0vd3oexODcUQ41rTFYCJyeDjkfJaQiF45IhwrKkxJFtrwRkIi+qeFcGSh2yj64YCQbKgciTgFz+LWJUclHBPmiJAsQrdPRI47gSQcM+eAkKx1Hog9aDP064YTRjmOmXLghqL8iHgNV25lWUUT3Ia0deeIet7mCu2grOrd5Znkdei2ifigTarXjaS+V1gzI9wdpe5EWMmWimPQlslvdOOZIQ2uQ+GKOIkDYc1abmSCHHAdN6HbJtKFNvleHWfzTNWOTIcGy/lI9a6InmhwI/cKiROn4Yu9Cd0uMT0a3MhGN6oEoc2Yr2u+zEXotolp03DTUoI1FVzIUk2Uyk6K0WgIm3UOxk6N+iuhJYLA+sS9QpoYcV/WqvJlKVEqgkM7wZRuarFCm++oJq9kF0U0NITVN6HbNXtoM9/VL0YJKxEdziVXb3Qr3egCwf2Rks/U4CYROQ2htkRkTJx4+GyU7xCpUJMXUb5uLKTgYgo0OGiJyJDUiIdiSJEs3M/hSUSGok48QrdJiHNxIrKpnNvL0O2aDKwvyLkJ3S4h+oL1PTTL0O1KHn2wYi7oXO8ZfaBibuic7xHuj6Zdhm6TSAvaGejumVBxoUSkB7ifMF2GbpNIA9qhDbfcr1BeM5HpBiUiZyDxEKfiLrhlzUVXJZnJjxtERF28h5B4iFOgHaRWPWfasGYCbqRGRFQn0gT3y3uXodsk4oM2RLlh/dKTp5CEG5GItID7Y1tUJCZ2cOfI+kzRqGPNyN1IjYho+EYJrQ2VeIg9aKs0V6xfn7ZPoncj3C97l4jUfCjr0G0SYaG9217z/BClC2tG7Ea4f73M92ZL2TLhwW3NRmiidiO0n5PPTeg2BYG78ewzJR6zg801GzGwZqRuhPs5w2XoNo0K7UlToqzyjGD7mo0YiNaNcLf7ej7XEOeunjOF3Ws2YmDNCN0Id0V4w6m7eO4ngW5Dt0kMB/ur2YiB6NwIrZvzr6f70G0aDO4nTdXjMlFoXWYMCdEhiGrJENqbsk9UItcb3I/ZovkSxPlwvJqNGIhqBQDuV3FPKx/C/a6nReg2ifPhtmYjhYToEETjRrjr+DaxtOtsaONg/650E7pN4jwYT81GDEThRmjFfOO1axr5EO7WeyjvkSjc1mz4J6nYEtyNcD8fElzYzoI2A1/yzAi7wkQzTKtmIwaCuxFO5Zrj1NRwRnBbszGHhOgQBHUjnILr5+5daxrx2IThtGo2YiCYG+F+3jGtrl3u26hpZIQnCKddsxEDQdwId7t207kGua9+Cl0ig/Oq2YiBIG6Eu6FMGlFAko2eAVTNRgyM6kaY2s2cuwVj6dimCUPVbMTGqG6Eu+mEDWO9JrlfyJJW4mZCUDUbKTCaG+Gu67zp87VNXy/kGvaX230yxrzv67XFcdzJ+AnAFwCLsK0RLXkB8NkYkw/5JrRDR/zu3EtjTDHke54E7R3PZxG6TXOBqtmYArcc2I1wdzBrb7nJXhyIa1AZ190ZY7728bqiHtrqwk8AvgHIgjZG9EUB4OtQbsQJ1AZAKVQf+nivswWEu/boBdYevZz7umIf2tnbPmIr1mJ6fAfw9xDXEAdIM/QhIGtsY+6/jTE3576m2EI7t8MXAEts7x5i2hQYyI2Q3GDrWr8aY+7Oeb2zBMTdEcu1KQpjzOU5rycszm4uYYVjWpPDiFPo3Y30fc2eKyC9qtncoa0P+AgrHkIAA7iRStRw1nXbWUDkPvrBJUS/weY1sqCNETHTmxvpM2/52xnt+Mvb/vuM15kd3M6zsYbNjF9D4iEOcw3gkT2USDg3k7vdC/fa3V6ry5Mq7iM3xnzo2oA54b78L7BuQwlR0ZWz3UjVhRhj3nZ5na4C4uc+eulPniqq2RADUeDM3EgfuZCTBUS5j3a4hGjpNoQYis5upOJCOl3LXXIgX7xt5T48aOfZuCX5DMCvzhViKDrnRiq5kIwdlpk9yYH0oVhTg9tBbN+gmg0Rlu/GmD9PecK51/SpDuSbtz1r90E7z8YKwDNsSCfxEKEpJ4xqfS46F1K43exUJ9Pagbhk4MbtznLMi/sMlrBhXBayLUIcofWwkkpe88EY87ntm5wiILfY9hfPZswLNc+GSJcn2N6Vp2MHurxdWVrQer6QU0KYpbd9d8LzksQlRFewrmsFiYdIjyvYBOtNi2N/eNvfGo+q0MqBnGNxUsIbxKaaDTE1DrqRaoqibWFZWwfid93+aDwqUTy38QzgFhIPMT0OuhEXsjy43Yu2XbpHHUhFmSbVdeuy1bdQeCLmRe1kQq74sZzusFWk0caB+PHQz3btixs3mG0F4BESDzEfCgB/Aqgdu2aMecC2S/cTWyzM3UZA/GrKuxbHRw3tchMbaM4NMQ9eYK/b98aYS2PM9yPlFw/e9tFK6oMhTKVKLenkqVNT9aaIuZAD+HnqALlTUxbHHIifPP3nlIbEhIvtFK6IqVPAVohfGmM+dBpda5OpZU9Ndqyq9ZiA+BbmofGoiHFZ53to/g0xXe5gF6i6NMbc9LBolJ/r/NJ4FA4IiLtrlxfdXYpl6y5R+tfRA4VIjycAXwG8NcZ8dQnQvmidB3lz4LGP3nZS4YsrCFtDA9zEtCgToj/blKd3xRhTkHyCvX4ykldN73cohPGVJ++xfYMi8RAT5AE2RHlrjPlzSPHw8MOYRhdSKyAucVKGLw+phC8SDzEhCtiajUtjzOeeQ5Q2+O/3semgphAm1d6XW0g8RLq8wF64P0PPM1wJY65IZnXJ2aYQZuFtJ9H74qYbWIZuhxAdyGETopcuIZqHbc4rvnlY1B2wJyCukKS8iz+lEL64gT+d17YQIgAF7ITIrzUbEV5rR8OYuhBm4W1HH744wbsN3Q4hWnIH4J8AOY2TMcY8kXyBzYcu6o6pC2H+8Laj/yehIjERP0+wCdEhajaGxh/iv6g+WCcgZZfNy0jdRZ1xVaZKmooYeYENUd4bY963GMQWK/9624vqgzshTKX7Nh+sST3gLUotREw8wIYod6Eb0hO5t/1H9cFqDsS/m/+LuFlBoYuIgwK28Oquh3EoUeG6cwvYWfoW1cerIYyvMPlQjToXF4stAjdDzJuyrPxDj4PYYiUvN6p5kKqAvD4Yef5DA+REKMpBbLHVbAyJH43s5BxfBcSVgWduNx+8SR2R+xABKLCt2Xgfac3GkPhmYicP4udAUsl/yH2IsSjLylPqdu2dSj1IvQPB7l09yvDF9bwsAjdDTJsC25qNEIPYYsWfpey188IXkHc1B8eGum3FEJw68fAeJDOSN25M1hSpzYPUhTAvEWeTl6EbICZFjg4TD/u4cVg76ya7PN3niK+jLvimYgGXJ/UFJKs5MBoqUywK0ZUCZ9ZsuILLb7BV23XnZLkK3IfIezNPofC2/1duvAH2+nZjTaDuVcEJcQJ3OGOejQ7rJl/AisjXKVSlukRquZuVG2+qf8Cu0sTE0UVuhKjwBLuWc+dZ9Zzz/YLu59+KJKYgIrBhywJeuJaEgLjelyxwM0QalAnRH2eEKBms01iin7B5KiLyKsLlDGWlgPjhQYwx2yJ0A0T0nFWz4UKUT7DCMcQI7ymIyC9snVgG4FVASpV9ibTC7t3xQ8QMKbANUYouL+Dyf2WIMnSSfkXyJeHaEt9cXAHI33g71QNiQnN+iJJy4uEfXXs4XIiyhBWOrK+GtWRFski0d8Y3FxcA8MavKqscEBOL0A0Qwclhu1/PSYguYef2DJmQvwBwT/J9pG6/EWNM7vXEvANsEtW/u/8au1HHqAicmBcFhq/ZCEEGOxXnh8DtOAfrQCp/jFERFb7MjzucMfGwV7PxBfGePwuS18aY76EbciKva8UAVkAWlQeFCMETtm4jVM3G2PxFsnMCOBDld1PrQGIkC90AMRhlzUbnxaK9mo1PSO9cuYCdmjOlUKYoN0hevAHwu/dgjA4kC90A0TtnTTw8Qs3GmCxIfkqoa/c/b/tqJ4maWlZYJEWBtGo2xuQWaazBtEcKIYxIl7Jm45xBbBm2biPrq2GRkZFcJlKlWvg7b5oeEOIMckyjZmNM/oLNB8VO4W0v3mCr6kX1SCFOoMC2QrTo8gKuZuML+hvElhIpuZBXfkP8tjAP3QBxkAfY2bcujTF/nioeJC9IXpN8BPAI4BrzE4+S5KbsVA5EdKGvmo2P0DSVPlckryIfJ7PzfacgIOoZioO+BrGlWrMxFl8QZzkFgL2ZyeIXkGqDxej0VbOxM/GwaGQJu6xECvzuC0isc6ECNkGXBW7DnChw/iC2BaZZszE0FwmEMSVX0TsQxxMkIGNwB9VsxMAnRBzG+KQiIP5UaqJfYph4WOySzAoEqQhIDq2J2yd9TDw855qNoVmEbkBbkhCQykxIojuxTzwsHCQXXUPJMUlCQBw5ElLmiChgQxTVbKTFFRIoovQF5PfGo+LgH0hA2pL6xMPCWz4yYgpfQGK3pA+ww55FMznOWCxaNRtREfv1CAD/JRPCGGMKkjl0YlcpMM2Jh0UCJCMgjp+QgJTc4byJhzOoZiNmFqEbUIcrEHwlKQExxtyRvMV875Kq2RBR8RsSyPRW+BG6ASPzAuA7gPfGmPfGmJN7U0hmJG9JPsOuRyLxEL2QUhK15Dus7Z66C1HNhoid3BeQJC5IY8wLyR+YZmVqgf4mHl721SghPHZuRm+Q5lSGU3IhqtkQKbFzzb2Bt84DySyFVbKcC/kbadeF5Ohn4mHVbIhQPFV7YTIk4kiMMd9Jxrz2aR0F+pl4WDUbIhTvyg1jzMsbJDLvQANfYSfijZ079LNYtGo25kMeugENlDetF8B24/r2eTF2a87B5Qxinf6tbNtbY8zXLuJB8hPJewDPsOFa1m8ThTiZzP1+AtJNor7iQpmPiEP8+lwsegmFKHMm1sgg83feuDEm5X4yMyFV+AwbymSB3l+LRYu++e/4IePibm4l/wLbQrICCdtj1yvzGcAa4921C2jiYTEcMTqQrPqHqoAsRmtKz7jlH0oRGYq+FoteQjUb4jCxC0gObAXkCU48UqkFqcNNffgVwKrnl+5jENsS81osWnTnqet5NjCZt/0CbAXk/yoHFaM0ZwDciF3gfBEpoJoNEYY8dAMaeM2Rlp0Ev7n93Dso+SSeS2Z+RrdlMfteLHoJiYc4jVgXeSvP49fwys+BlKQwF+NRjDEPJAu0S6z2tVi05tkQfZCHbkADpbkoyj+8AV6nC3yBvdCSdyAlLrF6CTsHxqLysBaLFjHSOc82JJWZyH6VG795fywvIv/A5DHGvBhjPgD42/0pB/DVGFNWiJ4kHi5EWboQZQPgGhIP0R//hG5AA5m3nZcbptxwUwVeu933iSzuOxqq2RAj8GKMeRu6EXVU9OGyzA36o3F/edtXiLMfelQ08bAYmZin6yxTGy9+x4IvILm3/Q4zRjUbIhB3oRtwgIX7nft/fBWQSiJ1gZmhxaJFYDoPiRiapgQqsL+sQw57151MT8whvHk2UpuYSEyPv48fEgz/2sj9B37bPW6rLtUFZKaEm2djhe08GxIPEZLvsboPh1+BmvsPVAXEf3AxWHMC4K2NsoGtC1kGbpIQgK1Hitl9AFst2OtY2Qlh3GC0cjfVuUFe0WLRIgH+jLFwrMTlBsucYF59vG5pyxz2YlsM1KbBUc2GSIS86yRUI7LwtvfG6FRDGMCrhHPjO5LAhSjXLkRZQ70pIm5eYCcFjx0//7E3r2+TA/Gf3Gkm8bHQIDaRKF8jT5yWlNdVXvfgngNxJexlTBblRUnySotFi4T53nWJjzGpRCC1Y3TqQhhg6zqyykSqwagMYnuErctXiCJS484YE+tSJFX8jpS87oAmAfHVJujdvVKzsYJqNkS6xLyOUR3ltV80Da6ty4EAu2rzBXYx69HQxMNigjwB+BBzl62P677N3G5juFUrIG6ZhAe4svYxJlpWzYaYMEmJh+OLt904R0lTCFN90uLc1jThEqIr2Ml5VkO+lxAByJGeeADb8OXl0BImhwTEty1fGo/qQKVmQxMPi6lyZ4xJTjzahi/AAQFx/3T55EUfvTHeYtEbaLFoMW3+NMakUChWR6vwBTjsQKpP7tQb4w1iU82GmAMF7JSgo3Y89Izf+9LNgTg6hTENEw8rRBFT5zsSn0/YjSPL3O7RYreDAuLCmDu3e+Vio4NvrpoNMUNyWOGIemRtS3yj8PPYwcccCLAbxnyrO8AJhz+ITYg5UMCOafmQsuso8UopALs+79H/6aiAuBiocLu1+QvXzfMD3ZaSFCI1nmCF4zKB4fin4E9/0WqG+DYOBNhamQs3Y/keLmn0HvEuyyfEOZTh/AdjzPuJCUdJGWH4PbAHMccPeS0t37jdJ2PM+yPHXwP4C0qcivR5gr0bR7nkZF+4/Oaj271r2wXdyoG4MvZSkY4mU+VGROIUsD0ql6XbmLJ4OPz8ZusFrlo5EOC1e2ftdlsrlNyISIgHAD9TmKujT1zy9Nnt5m4t6Va0zYGUidLC7S7bVqbKjYjIKWCH2L81xnyem3g4rr3to123Pq0FxOFPP79s+yRjTOFULfbp68U8KBOi711PyvcZhCiHKMOX4tTkcOsQpsSVpF/AfgmXp37wLn+iIjMRghw2RLkL3I5ocL2qK7f7tzHm5pTnn+pAgG2C5QK71qcVxpiyF0duRIxBAXuuXbqCr7uwzYmOv9zvF3SYOKyLA7mA7dLt7EK815IbEUNxB+s28sDtiJZz3QfQwYE4sfBdSOfRtXIjomeeYNdaeWuM+SrxOMpZ7gPo4ECAPRdSwCajzkpCyY2IjpQJ0R+JrLMSBX24D6BbDqTqQjJ0yIXUvKbciDiFBwCfjTFv3SjYInSDEuNs9wF0dCBAv7mQmteWGxF1FNiWlRdhm5IufbkPoKMDAWpzIWe7EO+15UZESV3NRhG2Senibvy9uA/gDAFxfMd2CP8317jecMr4HjY5JuZFDpsQvXQJUZ0D/XCN7YxjP86NGjqHMCVurMut2209RqbD+9xgq5ximhSwpdR3chn9M0Tnx9kCAgBuNrLM7Q42J6RyI5PlDsA/Mx2HMhpuutGl2/3aR1FdXwLyCXbGdeDE0Xwd3+8GciOpM4t5NmKhMt/H0Tl92tKLgAAAyTW2q8oNPqrRfSD30NoyKVEmRH8qpzEulevzQ3RFdm79l5LnvhOqDe954dacEXFzT+tSRQBol1gpWR1/RiBI3ngNvT3+jN7ed0FyM971IFqwoV2+NBvrPBD70N5kn913MsqNvTOusRvvJBot2Um5kRh4Jrminb1ORID7Pkp6q9UaDNr1b0sejz+j9/eXGxmfNa1NjvfuNkNor4WS0a/FztDGvCU3Ad5fbmR4NrSfcTb29yuOw4DRwNlwN+4K1njKjQzBikqIRg93b6A3odtzMgwcynjtkBs5n0fahKhClARgqqFLFQYOZSptkRs5jWda4U3H+oq0Q5cq3A9lFhG0R27kMPdsWL5UxA8jumn3AndDmQ0jsMGUG6myoWo2koe7BWPphi5VuHvXvz/+jOGh3IhqNiYEySvuFoxlodvUG7QX66N38kZT0ML5uZFHqmZjUnD/+lqGblPvcFchyYiSO+4LWI10AYdgQ9VsTBbunrvxjnU5F+7GaBtGdhekzdf4Ipc6GsQ2cVjJezCya6p3uKuW69DtqULrRvxMdmqoZmMm0Lr6kmdG5OoHhbvx2mijdk+BabmRMiE6jxNI1JVIzMdp1vzzy9BtqoPxuxHVbMwQ7idNb0K3aXS4a7/IiLsTGZcb2dDOu5KF/lxEGLibBoiiLCII3E0ARR3DMbwbWTFikRXjwN1Ju6afND0Gd4u5NrF/IBzXjahmQ7zC/Ruuzgtgz5JFr6oc1o2Ug9iy0P+niAfuDgmJ2q0HgbtJoSTq+NmvG1HNhqiF+0WYOk+qcD+znERFHc9zIxuqZkMcoEY8lqHbFC2pighwkhtRzYZohcSjAzUfWkoicsiNrHUCiLbUXAdRFlxGScoiAuy4kQ1VsyFOJPXzPwr0IYo5ovO+R/Rhijmh830A9KGKOaDzfEBqPtw11fUpJoLEYwTch7xTbCYREanD3fJ0Uj11w8H9OpFHqp5CJIrEIwA1IqJxASI5uDv+61niMTLcnwR5GbpNQhyD+8WGugGGgrtzI5Cq1hMRQzJTCB4ZNXHkmkquisigXX9IPYkxwv1usI2UXcRCjVNWN21ssD65ugzdLjFfavIdytXFDveTqytZRTE2zhVv5IoTxOVFFNKIINSELPe6iSUG9ytXyTmunyFGg7aXZV0556JZSF6ciItBbytf6Jqan0P0DO3UlHK9U4T70w0+684g+qDBdawUskwM1mfE5UZEZ2pcxzM1Y/q0qXEjyo2Ik6DNr1VdhxKlc6HBjWyopSPFAdx5U+1h2ch1zBTa8uJNzZ0kC902ERe0pQHVc+VWrmPmNNxV6P6mk2PmuJtMNVzRIDixC+uz6eqtmSnufFjVnA/L0G0TEdMQ1mx04syDBuGQIxWnwf1yeAnJhDkgHCsqJya6wG1+REIyUQ4Ix5rqlRN9cERIrmVt00PCIUbngJA803bpZaHbKA5DW0i4lnCIYHhCsqk5Ee+pwqKocN/XdcP3taK6ZEUoaJOt1WkD6E7WG7mScND2qK1qvhs5RhEXB07W0pUsqVzJ4NDmNprc4Ubfg4iaI3b52YmMQpwecaJx3eAE6T7zReh2CnESniupJl19MdEdsQMtRONRn62YBM6VLLk/Athn7S4IJfQaoO1BuWW9uyOVdxJTp6WYbDx3koVucyhoHdwN67tdfadxK+ENgwndgLlDmw/5CGABIGs4rADwBOBfAE/GmHyEpo2KE8orAH+434sDhz/AfhYPxphi6LaJZiQgEeHuogvYi2gB4FD8/uR+/gOQAyhSuZhoE5qZ+ykF49j/mgP41xjzMGzrxClIQCKmIihXaHYoPk8AXmDv0C9uH2O6FucmMlhRuALwO7btz1q8RI6t48qNMS/9t1L0gQQkITyb71v9U3sZXkXFUcC6mC68896/FItTyV0bfmGi4dmUkYAkDm03ZSkqF7DC0vViHopStAokGHKJZiQgE8YTF2A3KfmHt91VbAr34++XTqYMoyQSE+f/ARSKAQyyU4HqAAAAAElFTkSuQmCC";

  // ====== fin fetchBudgets ======

  // 🔹 Token & navegación
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem("token");
          navigate("/login");
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate("/login");
      }
    }
  }, [navigate]);

  // 🔹 Cargar Temporadas y Clientes
  useEffect(() => {
    (async () => {
      try {
        const [ts, cs] = await Promise.all([getTemporadas(), getClientes()]);
        setTemporadas(ts || []);
        setClientes(cs || []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  // 🔹 Carga inicial de presupuestos (sin incoterms aún)
  useEffect(() => {
    fetchBudgets();
  }, [fetchBudgets]);

  // 🔹 Escandallos
  useEffect(() => {
    const fetchEscandalloData = async () => {
      try {
        const grupos = await getEscandalloGrupos();
        setEscandalloGrupos(grupos || []);
        if (grupos.length > 0) {
          const subgrupos = await getEscandalloSubgruposMuestras(
            grupos[0].ID_GRUPO,
          );
          setEscandalloSubgrupos(subgrupos || []);
        }
      } catch (error) {
        console.error("Error al cargar datos de escandallos:", error);
      }
    };
    fetchEscandalloData();
  }, []);

  // 🔹 Incoterms + refresco budgets
  useEffect(() => {
    const loadData = async () => {
      try {
        const resIncoterms = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/incoterms`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        setIncoterms(resIncoterms.data || []);
        await fetchBudgets(resIncoterms.data || []);
      } catch (err) {
        console.error("Error cargando incoterms", err);
      }
    };
    loadData();
  }, [fetchBudgets]);

  // 🔹 Catálogo productos y muestras
  useEffect(() => {
    const loadProductosYMuestras = async () => {
      try {
        const data = await getProductosYMuestras();
        setProductosYMuestras(data || []);
      } catch (error) {
        console.error("Error cargando productos y muestras:", error);
      }
    };
    loadProductosYMuestras();
  }, []);

  useEffect(() => {
    const loadModelosTipo = async () => {
      try {
        const data = await getModelosTipo();
        setModelosTipo(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error cargando VolumenPrenda (modelosTipo):", error);
      }
    };
    loadModelosTipo();
  }, []);

  // 🔹 Recalcular cuando tengamos incoterms + catálogo + listas
  useEffect(() => {
    if (
      incoterms.length > 0 &&
      productosYMuestras.length > 0 &&
      modelosTipo.length > 0 &&
      (temporadas.length > 0 || clientes.length > 0)
    ) {
      fetchBudgets(incoterms);
    }
  }, [
    fetchBudgets,
    incoterms,
    productosYMuestras,
    modelosTipo,
    temporadas,
    clientes,
  ]);

  // 🧩 Detectar si viene un presupuesto por query string y abrirlo directamente
  const [searchParams, setSearchParams] = useSearchParams();
  const openedFromUrlRef = useRef(null);

  useEffect(() => {
    const idFromUrl = searchParams.get("idPresupuesto");
    if (!idFromUrl) {
      openedFromUrlRef.current = null;
      return;
    }
    if (proyectos.length === 0) return;
    // Evita reabrir el mismo id tras cerrar (p. ej. al refrescar la grid)
    if (openedFromUrlRef.current === String(idFromUrl)) return;

    const found = proyectos.find(
      (p) => String(p.IdPresupuesto) === String(idFromUrl),
    );
    if (found) {
      openedFromUrlRef.current = String(idFromUrl);
      setSelectedBudget(found);
      setSelectedId(found.IdPresupuesto);
      setOpenDrawer(true);
    }
  }, [searchParams, proyectos]);

  const [selectedId, setSelectedId] = React.useState(null);

  const isBudgetLeafGridRow = (params) => {
    const rowId = String(params?.id ?? "");
    if (rowId.startsWith("auto-generated-row-null/")) return false;
    if (params?.rowNode?.type === "group") return false;
    if (params?.rowNode?.type === "leaf") {
      return params?.row?.IdPresupuesto != null;
    }
    const hasChildren =
      Array.isArray(params?.rowNode?.children) &&
      params.rowNode.children.length > 0;
    return params?.row?.IdPresupuesto != null && !hasChildren;
  };

  const handleRowClick = (params) => {
    if (!isBudgetLeafGridRow(params)) return;
    setSelectedId(params.id);
    setSelectedBudget(params.row);
    setOpenDrawer(true);
  };

  const refreshGridAfterDrawer = useCallback(
    async (closedBudget) => {
      await fetchBudgets(incoterms);

      const id = closedBudget?.IdPresupuesto;
      const numero = closedBudget?.NumeroPresupuesto || id;
      if (!id || !numero) return;

      budgetImagesCache.delete(id);
      budgetImagesAttemptedRef.current.delete(id);
      invalidatePresupuestoFilesCache(numero);

      try {
        const files = await getFileContent(numero);
        const imgFile = pickEstimateGridThumbnailFile(files);
        budgetImagesCache.set(id, imgFile);
        setBudgetImages((prev) => ({ ...prev, [id]: imgFile }));
      } catch {
        budgetImagesCache.set(id, null);
        setBudgetImages((prev) => ({ ...prev, [id]: null }));
      }
    },
    [fetchBudgets, incoterms],
  );

  const handleDrawerClose = useCallback(() => {
    const closedBudget =
      selectedBudget ||
      proyectos.find((p) => p.IdPresupuesto === selectedId) ||
      null;

    setOpenDrawer(false);
    setSelectedBudget(null);
    setSelectedId(null);

    // Quitar ?idPresupuesto= de la URL para que no se reabra al refrescar
    if (searchParams.has("idPresupuesto")) {
      const next = new URLSearchParams(searchParams);
      next.delete("idPresupuesto");
      setSearchParams(next, { replace: true });
    }
    // Marcar el id actual como ya consumido (por si el replace tarda)
    const closedId = closedBudget?.IdPresupuesto;
    if (closedId != null) {
      openedFromUrlRef.current = String(closedId);
    }

    void refreshGridAfterDrawer(closedBudget);
  }, [
    selectedBudget,
    selectedId,
    proyectos,
    refreshGridAfterDrawer,
    searchParams,
    setSearchParams,
  ]);

  const exportToExcel = () => {
    // Exporta directamente todas las hojas
    const allPresupuestos = proyectos.map((item) => ({
      ...item,
    }));

    const ws = XLSX.utils.json_to_sheet(allPresupuestos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Presupuestos");
    XLSX.writeFile(wb, "presupuestos.xlsx");
  };

  const clearPhotoSearch = useCallback(() => {
    setPhotoSearchScores(null);
    setPhotoSearchPreview(null);
    if (photoSearchInputRef.current) photoSearchInputRef.current.value = "";
  }, []);

  const photoSearchBudgetNumbers = React.useMemo(
    () => [
      ...new Set(
        proyectos
          .filter((item) => item.IdPresupuesto && item.NumeroPresupuesto)
          .map((item) => item.NumeroPresupuesto),
      ),
    ],
    [proyectos],
  );

  const handlePhotoSearchFile = useCallback(
    async (file) => {
      if (!file?.type?.startsWith("image/")) {
        window.alert("Upload an image file (JPG, PNG, WEBP).");
        return;
      }

      const numerosPresupuesto = photoSearchBudgetNumbers;

      if (!numerosPresupuesto.length) {
        window.alert("No estimates available to compare photos against.");
        return;
      }

      setPhotoSearchCandidateCount(numerosPresupuesto.length);
      setPhotoSearchLoading(true);
      try {
        const base64Sharp = await fileToSearchBase64Resized(file, 384, 0.82);
        setPhotoSearchPreview(base64Sharp);

        const result = await searchEstimateImageHits(
          base64Sharp,
          numerosPresupuesto,
        );
        const clipScores = resolvePhotoSearchScores(result?.hits || []);
        const rankedScores = Object.fromEntries(
          Object.entries(clipScores)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 12),
        );
        setPhotoSearchScores(rankedScores);

        if (!Object.keys(rankedScores).length) {
          window.alert(
            "No estimates matched this photo. Try a clearer product shot, or check that the estimate has a reference image uploaded.",
          );
        }
      } catch (error) {
        console.error("Estimate photo search failed:", error);
        clearPhotoSearch();
        const isTimeout = error?.code === "ECONNABORTED";
        const isNetwork =
          error?.message === "Network Error" || error?.code === "ERR_NETWORK";
        const apiError =
          error?.response?.data?.error ||
          error?.response?.data?.details?.error ||
          error?.message;
        window.alert(
          isTimeout
            ? t("EstimatesPage.photoSearchTimeout", {
                defaultValue:
                  "Photo search timed out while comparing estimate photos. Try again — repeat searches are usually faster.",
              })
            : isNetwork
              ? t("EstimatesPage.photoSearchNetworkError", {
                  defaultValue:
                    "Photo search lost connection to the server. Wait a moment and try again.",
                })
              : apiError
                ? `Photo search failed: ${apiError}`
                : t("EstimatesPage.photoSearchUnavailable", {
                    defaultValue:
                      "Photo search is unavailable right now. Check that the AI search service is running.",
                  }),
        );
      } finally {
        setPhotoSearchLoading(false);
        setPhotoSearchCandidateCount(0);
      }
    },
    [clearPhotoSearch, photoSearchBudgetNumbers, t],
  );

  const handlePhotoSearchDragOver = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!photoSearchLoading) setPhotoSearchDragging(true);
    },
    [photoSearchLoading],
  );

  const handlePhotoSearchDragLeave = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    setPhotoSearchDragging(false);
  }, []);

  const handlePhotoSearchDrop = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      setPhotoSearchDragging(false);
      if (photoSearchLoading) return;

      const file = Array.from(event.dataTransfer?.files || []).find((item) =>
        item.type?.startsWith("image/"),
      );
      if (file) void handlePhotoSearchFile(file);
    },
    [handlePhotoSearchFile, photoSearchLoading],
  );

  const filteredProyectos = React.useMemo(() => {
    let list = proyectos.filter((item) =>
      estimateMatchesSearchTerm(item, searchTerm),
    );

    if (photoSearchScores && Object.keys(photoSearchScores).length > 0) {
      list = list.filter((item) =>
        budgetMatchesPhotoSearch(item, photoSearchScores),
      );
      list = [...list].sort(
        (a, b) =>
          getBudgetPhotoSearchScore(b, photoSearchScores) -
          getBudgetPhotoSearchScore(a, photoSearchScores),
      );
    } else {
      list = [...list].sort((a, b) =>
        compareEstimateTreeRows(a, b, temporadas, treeGroupMode),
      );
    }

    return list;
  }, [proyectos, searchTerm, photoSearchScores, temporadas, treeGroupMode]);

  const photoSearchMatchCount = React.useMemo(() => {
    if (!photoSearchScores || !Object.keys(photoSearchScores).length) return 0;
    return proyectos.filter((item) =>
      budgetMatchesPhotoSearch(item, photoSearchScores),
    ).length;
  }, [proyectos, photoSearchScores]);

  const mobileBudgetsByGroup = React.useMemo(() => {
    const groups = {};
    filteredProyectos
      .filter((p) => p.IdPresupuesto)
      .forEach((budget) => {
        const key =
          treeGroupMode === "client"
            ? budget.ClienteNombre || budget.MarcaNombre || "N/A"
            : budget.TemporadaNombre || "N/A";
        if (!groups[key]) groups[key] = [];
        groups[key].push(budget);
      });
    return groups;
  }, [filteredProyectos, treeGroupMode]);

  const formatMoney = (value) =>
    new Intl.NumberFormat("es-ES", { minimumFractionDigits: 2 }).format(
      value || 0,
    );

  const renderMobileBudgetCard = (budget) => {
    const milestone =
      budget.StatusMilestone || budget.PresupuestoEstado || "Created";

    return (
      <Box
        key={budget.id || budget.IdPresupuesto}
        onClick={() => handleRowClick({ id: budget.id, row: budget })}
        sx={{
          ...pageMobileCardSx(theme, {
            accentColor: theme.palette.primary.main,
            active: selectedId === budget.id,
          }),
          cursor: "pointer",
        }}
      >
        <Stack direction="row" spacing={1.25} alignItems="flex-start">
          <Box
            sx={{
              width: 72,
              minWidth: 72,
              height: 88,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              overflow: "hidden",
              bgcolor: alpha(theme.palette.background.default, 0.55),
            }}
          >
            <BudgetListThumbnail
              budget={budget}
              file={budgetImages[budget.IdPresupuesto]}
              onRequest={requestBudgetImage}
              lazy
              enablePreview
            />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary" noWrap>
              {budget.ClienteNombre || budget.MarcaNombre || "—"} ·{" "}
              {budget.ProyectoNombre || "—"}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 800, lineHeight: 1.25 }}
              noWrap
            >
              {budget.DiseñoMuestra ||
                budget.designCliente ||
                budget.NombrePresupuesto ||
                "—"}
            </Typography>

            <Stack
              direction="row"
              spacing={0.5}
              useFlexGap
              flexWrap="wrap"
              sx={{ mt: 0.65 }}
            >
              <Chip
                size="small"
                label={budget.DiseñoMuestra || budget.designCliente || "—"}
                sx={designChipSx(budget.colorGroup, theme)}
              />
              <Chip
                size="small"
                label={milestone}
                sx={statusChipSx(milestone, theme, alpha)}
              />
              <Chip
                size="small"
                label={budget.StatusDate || "-"}
                sx={statusDateChipSx(theme, alpha)}
              />
              {budget.ProveedorNombre ? (
                <EntityAvatar
                  name={budget.ProveedorNombre}
                  color={getSupplierColor(budget.ProveedorNombre)}
                  size={28}
                  fontSize="0.65rem"
                  title={budget.ProveedorNombre}
                  inline
                />
              ) : null}
            </Stack>

            <Stack direction="row" spacing={1.5} sx={{ mt: 0.75 }}>
              <Typography
                variant="caption"
                sx={{ fontWeight: 700, color: "error.main" }}
              >
                Cost {formatMoney(budget.CosteUnitario)}
              </Typography>
              <Typography
                variant="caption"
                sx={{ fontWeight: 700, color: "success.dark" }}
              >
                Sale {formatMoney(budget.VentaUnitaria)}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Box>
    );
  };

  const isGroupExpandedByDefault = useCallback(
    (node) => expandedIds.has(node.id),
    [expandedIds],
  );

  const handleRowExpansionChange = useCallback((node) => {
    if (!node?.id) return;
    setExpandedIds((prev) => {
      const copy = new Set(prev);
      if (node.childrenExpanded) copy.add(node.id);
      else copy.delete(node.id);
      if (copy.size === prev.size && [...copy].every((id) => prev.has(id))) {
        return prev;
      }
      return copy;
    });
  }, []);

  useEffect(() => {
    const api = apiRef.current;
    if (!api?.subscribeEvent) return undefined;

    return api.subscribeEvent("rowExpansionChange", handleRowExpansionChange);
  }, [apiRef, handleRowExpansionChange]);

  /** Suma comunicaciones en nodos del árbol (temporada / cliente / proyecto). */
  const commsAggByGroupPath = React.useMemo(() => {
    const map = new Map();
    const bump = (pathKey, leaf) => {
      if (!pathKey) return;
      const prev = map.get(pathKey) || {
        CommCount: 0,
        ClientOfferCount: 0,
        OpenRfqCount: 0,
        RfqCount: 0,
        HasComms: false,
      };
      const commCount = Number(leaf.CommCount) || 0;
      const clientOfferCount = Number(leaf.ClientOfferCount) || 0;
      const openRfq = Number(leaf.OpenRfqCount) || 0;
      const rfqCount = Number(leaf.RfqCount) || 0;
      map.set(pathKey, {
        CommCount: prev.CommCount + commCount,
        ClientOfferCount: prev.ClientOfferCount + clientOfferCount,
        OpenRfqCount: prev.OpenRfqCount + openRfq,
        RfqCount: prev.RfqCount + rfqCount,
        HasComms:
          prev.HasComms ||
          Boolean(leaf.HasComms) ||
          commCount > 0 ||
          clientOfferCount > 0 ||
          rfqCount > 0,
      });
    };

    for (const row of filteredProyectos) {
      if (row?.IdPresupuesto == null) continue;
      const season = String(row.TemporadaNombre || "N/A").trim();
      const client = String(
        row.ClienteNombre || row.MarcaNombre || "N/A",
      ).trim();
      const project = String(row.ProyectoNombre || "N/A").trim();
      if (treeGroupMode === "client") {
        bump(client, row);
        bump(`${client}/${season}`, row);
        bump(`${client}/${season}/${project}`, row);
      } else {
        bump(season, row);
        bump(`${season}/${client}`, row);
        bump(`${season}/${client}/${project}`, row);
      }
    }
    return map;
  }, [filteredProyectos, treeGroupMode]);

  const sumCommsFromLeaves = React.useCallback((leafRows) => {
    let CommCount = 0;
    let ClientOfferCount = 0;
    let OpenRfqCount = 0;
    let RfqCount = 0;
    let HasComms = false;
    for (const leaf of leafRows) {
      if (!leaf) continue;
      const c = Number(leaf.CommCount) || 0;
      const clientOffers = Number(leaf.ClientOfferCount) || 0;
      const o = Number(leaf.OpenRfqCount) || 0;
      const r = Number(leaf.RfqCount) || 0;
      CommCount += c;
      ClientOfferCount += clientOffers;
      OpenRfqCount += o;
      RfqCount += r;
      HasComms =
        HasComms ||
        Boolean(leaf.HasComms) ||
        c > 0 ||
        clientOffers > 0 ||
        r > 0;
    }
    return { CommCount, ClientOfferCount, OpenRfqCount, RfqCount, HasComms };
  }, []);

  const collectTreeLeafRows = React.useCallback(
    (rootId) => {
      const api = apiRef.current;
      if (!api?.getRowNode) return [];
      const leaves = [];
      const stack = [rootId];
      while (stack.length) {
        const id = stack.pop();
        const node = api.getRowNode(id);
        if (!node) continue;
        if (node.type === "leaf") {
          const row = api.getRow?.(id) || null;
          if (row?.IdPresupuesto != null) leaves.push(row);
          continue;
        }
        const children = node.children || [];
        for (let i = 0; i < children.length; i++) stack.push(children[i]);
      }
      return leaves;
    },
    [apiRef],
  );

  const getCommsMetaForGridRow = React.useCallback(
    (params) => {
      if (isBudgetLeafGridRow(params)) {
        return {
          CommCount: Number(params.row?.CommCount) || 0,
          ClientOfferCount: Number(params.row?.ClientOfferCount) || 0,
          OpenRfqCount: Number(params.row?.OpenRfqCount) || 0,
          RfqCount: Number(params.row?.RfqCount) || 0,
          HasComms: Boolean(params.row?.HasComms),
        };
      }

      // 1) Preferir suma real de hojas del nodo (cliente / proyecto / temporada)
      const leafRows = collectTreeLeafRows(params?.id);
      if (leafRows.length) {
        const summed = sumCommsFromLeaves(leafRows);
        if (
          summed.HasComms ||
          summed.CommCount > 0 ||
          summed.ClientOfferCount > 0 ||
          summed.RfqCount > 0
        ) {
          return summed;
        }
      }

      // 2) Fallback por path del id / rowNode
      const candidates = [];
      const rowId = String(params?.id ?? "");
      const prefixes = ["auto-generated-row-null/", "auto-generated-row-/"];
      for (const prefix of prefixes) {
        if (rowId.startsWith(prefix)) {
          candidates.push(rowId.slice(prefix.length));
        }
      }
      const nodePath = params?.rowNode?.path;
      if (Array.isArray(nodePath) && nodePath.length) {
        candidates.push(
          nodePath
            .map((p) => String(p?.key ?? p ?? "").trim())
            .filter(Boolean)
            .join("/"),
        );
      }
      const groupingKey = params?.rowNode?.groupingKey;
      if (groupingKey != null) {
        candidates.push(String(groupingKey).trim());
      }

      for (const key of candidates) {
        if (!key) continue;
        const hit = commsAggByGroupPath.get(key);
        if (hit) return hit;
        try {
          const decoded = key
            .split("/")
            .map((s) => decodeURIComponent(s))
            .join("/");
          const hit2 = commsAggByGroupPath.get(decoded);
          if (hit2) return hit2;
        } catch {
          /* ignore */
        }
      }
      return null;
    },
    [collectTreeLeafRows, sumCommsFromLeaves, commsAggByGroupPath],
  );

  const columns = [
    // {
    //   field: "ProyectoNombre",
    //   headerName: "",
    //   width: 0.5,
    //   sortable: false,
    //   filterable: false,
    //   disableColumnMenu: true,
    //   hideable: false,
    //   minWidth: 0.5,
    //   maxWidth: 0.5,
    //   renderCell: () => null, // mantenemos tu layout: esta "columna-gancho" vacía
    // },

    {
      field: "designCliente",
      headerName: "Client's Design",
      width: 170,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        const value =
          params.value ||
          params.row?.designCliente ||
          params.row?.DiseñoMuestra ||
          "—";
        return (
          <Chip
            size="small"
            label={value}
            title={value}
            sx={designChipSx(params.row?.colorGroup, theme)}
          />
        );
      },
    },
    /* FOTO */
    {
      field: "Foto",
      headerName: "Article",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        if (!params.row?.IdPresupuesto) {
          return <span style={{ color: "#aaa" }}>—</span>;
        }
        return (
          <BudgetListThumbnail
            budget={params.row}
            file={budgetImages[params.row.IdPresupuesto]}
            onRequest={requestBudgetImage}
            enablePreview
          />
        );
      },
    },

    /*    {
      field: "NombrePresupuesto",
      headerName: "Budget Name",
      width: 300,
      renderCell: (params) => (
        <span
        
        >
          {params.value}
        </span>
      ),
    }, */
    /*   { field: "TemporadaNombre", headerName: "Season", width: 100 }, */

    /*     {
      field: "PresupuestoEstado",
      headerName: "Status",
      width: 120,
      renderCell: (params) => (
        <span
          style={{
            color: statusColors[params.value] || "black",
            fontWeight: "bold",
          }}
        >
          {params.value}
        </span>
      ),
    }, */
    {
      field: "StatusDate",
      headerName: "Status Date",
      width: 210,
      sortComparator: (_, __, param1, param2) =>
        (param1?.row?.StatusDateSort || 0) - (param2?.row?.StatusDateSort || 0),
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        const milestone = params.row?.StatusMilestone || "Created";

        return (
          <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            sx={{ minWidth: 0 }}
          >
            <Chip
              size="small"
              label={milestone}
              sx={statusChipSx(milestone, theme, alpha)}
            />
            <Chip
              size="small"
              label={params.value || "-"}
              sx={statusDateChipSx(theme, alpha)}
            />
          </Stack>
        );
      },
    },
    {
      field: "HasComms",
      headerName: "Mail",
      width: 96,
      minWidth: 88,
      align: "center",
      headerAlign: "center",
      sortable: true,
      renderCell: (params) => {
        const isLeaf = isBudgetLeafGridRow(params);
        const groupExpanded =
          !isLeaf &&
          (params?.rowNode?.childrenExpanded === true ||
            expandedIds.has(params?.id));
        if (groupExpanded) return null;

        const meta = getCommsMetaForGridRow(params);
        if (!meta) return null;
        const commCount = Number(meta.CommCount || 0);
        const clientOfferCount = Number(meta.ClientOfferCount || 0);
        const openRfq = Number(meta.OpenRfqCount || 0);
        const hasSupplier = commCount > 0 || openRfq > 0;
        const hasClient = clientOfferCount > 0;
        const hasAnything = Boolean(meta.HasComms) || hasSupplier || hasClient;
        if (!hasAnything) {
          if (!isLeaf) return null;
          return (
            <Typography variant="caption" color="text.disabled">
              —
            </Typography>
          );
        }

        const supplierBadge =
          commCount > 0 ? commCount : openRfq > 0 ? openRfq : 0;
        const titleParts = [
          hasSupplier
            ? [
                commCount
                  ? `${commCount} email${commCount === 1 ? "" : "s"} proveedor`
                  : null,
                openRfq
                  ? `${openRfq} RFQ pendiente${openRfq === 1 ? "" : "s"}`
                  : null,
              ]
                .filter(Boolean)
                .join(" · ")
            : null,
          hasClient
            ? `${clientOfferCount} oferta${clientOfferCount === 1 ? "" : "s"} a cliente`
            : null,
          !isLeaf ? "Suma del grupo" : null,
        ].filter(Boolean);

        return (
          <Tooltip title={titleParts.join(" · ") || "Hay comunicaciones"}>
            <Stack direction="row" spacing={0.75} alignItems="center">
              {hasSupplier ? (
                <Badge
                  badgeContent={
                    supplierBadge > 1 || openRfq > 0 ? supplierBadge : 0
                  }
                  color={openRfq > 0 ? "warning" : "primary"}
                  overlap="circular"
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.65rem",
                      minWidth: 16,
                      height: 16,
                    },
                  }}
                >
                  {openRfq > 0 ? (
                    <MarkEmailUnreadOutlinedIcon
                      sx={{ color: theme.palette.warning.main, fontSize: 20 }}
                    />
                  ) : (
                    <MailOutlineIcon
                      sx={{ color: theme.palette.primary.main, fontSize: 20 }}
                    />
                  )}
                </Badge>
              ) : null}
              {hasClient ? (
                <Badge
                  badgeContent={clientOfferCount > 1 ? clientOfferCount : 0}
                  color="success"
                  overlap="circular"
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.65rem",
                      minWidth: 16,
                      height: 16,
                    },
                  }}
                >
                  <MailOutlineIcon sx={{ color: "#00c2a3", fontSize: 20 }} />
                </Badge>
              ) : null}
            </Stack>
          </Tooltip>
        );
      },
    },
    {
      field: "FechaCrear",
      headerName: "Created",
      width: 120,
      renderCell: (params) => (
        <span style={{ color: "#1976d2", fontWeight: "bold" }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "FechaPresentacion",
      headerName: "Offered",
      width: 120,
      renderCell: (params) => (
        <span style={{ color: "orange", fontWeight: "bold" }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "FechaCancelacion",
      headerName: "Cancelled",
      width: 120,
      renderCell: (params) => (
        <span style={{ color: "red", fontWeight: "bold" }}>{params.value}</span>
      ),
    },
    {
      field: "FechaAceptacion",
      headerName: "Accepted",
      width: 120,
      renderCell: (params) => (
        <span style={{ color: "#00c2a3", fontWeight: "bold" }}>
          {params.value}
        </span>
      ),
    },

    {
      field: "ProveedorNombre",
      headerName: "Supplier",
      width: 56,
      minWidth: 52,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <EntityAvatar
            name={params.value}
            color={getSupplierColor(params.value)}
            size={30}
            fontSize="0.68rem"
            title={params.value}
          />
        );
      },
    },
    { field: "Notas", headerName: "Notes", width: 200 },
    {
      field: "IncotermNombre",
      headerName: "Incoterm",
      width: 120,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return <span style={{ fontWeight: 500 }}>{params.value || "-"}</span>;
      },
    },

    {
      field: "Units",
      headerName: "Units Acc.",
      width: 100,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <strong style={{ color: "#000" }}>
            {new Intl.NumberFormat("es-ES", {
              minimumFractionDigits: 0,
            }).format(params.value || 0)}
          </strong>
        );
      },
    },
    {
      field: "CosteUnitario",
      headerName: "Cost Unit",
      width: 120,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <strong style={{ color: "red" }}>
            {new Intl.NumberFormat("es-ES", {
              minimumFractionDigits: 2,
            }).format(params.value || 0)}
          </strong>
        );
      },
    },
    {
      field: "VentaUnitaria",
      headerName: "Sale Unit",
      width: 120,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <strong style={{ color: "#00c2a3" }}>
            {new Intl.NumberFormat("es-ES", {
              minimumFractionDigits: 2,
            }).format(params.value || 0)}
          </strong>
        );
      },
    },
    {
      field: "MargenUnitario",
      headerName: "Margin Unit",
      width: 120,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <strong style={{ color: "#1976d2" }}>
            {params.value != null
              ? new Intl.NumberFormat("es-ES", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(params.value)
              : "-"}
          </strong>
        );
      },
    },
    {
      field: "Margen",
      headerName: "Margen",
      width: 120,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <strong style={{ color: "#1976d2" }}>
            {params.value != null
              ? `${parseFloat(params.value).toFixed(2)}%`
              : "-"}
          </strong>
        );
      },
    },

    {
      field: "CosteConvertido",
      headerName: "Cost Acc.",
      width: 120,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <strong style={{ color: "red" }}>
            {new Intl.NumberFormat("es-ES", {
              minimumFractionDigits: 2,
            }).format(params.value || 0)}
          </strong>
        );
      },
    },
    {
      field: "Venta",
      headerName: "Sales Acc.",
      width: 120,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <strong style={{ color: "#00c2a3" }}>
            {new Intl.NumberFormat("es-ES", {
              minimumFractionDigits: 2,
            }).format(params.value || 0)}
          </strong>
        );
      },
    },

    /*     {
      field: "UnitsUnitario",
      headerName: "Units",
      width: 100,
      renderCell: (params) => {
        if (!isBudgetLeafGridRow(params)) return null;
        return (
          <strong style={{ color: "#000" }}>
            {new Intl.NumberFormat("es-ES", {
              minimumFractionDigits: 0,
            }).format(params.value || 0)}
          </strong>
        );
      },
    }, */
  ];

  const accent = theme.palette.primary.main;
  const shellFill =
    theme.palette.mode === "dark"
      ? alpha(theme.palette.background.paper, 0.88)
      : alpha(theme.palette.common.white, 0.86);
  const pageGradient =
    theme.palette.mode === "dark"
      ? theme.palette.background.default
      : theme.palette.grey[50];
  const heroShellSx = {
    ...pageHeroShellSx(theme, { sticky: !isMobile }),
    mb: { xs: 2, md: 1.25 },
    flexShrink: 0,
    ...(theme.palette.mode === "light"
      ? {
          background: theme.palette.background.paper,
          borderColor: alpha(accent, 0.2),
          boxShadow: `0 10px 32px ${alpha(theme.palette.common.black, 0.08)}`,
        }
      : {}),
  };
  const toolbarIconSx = {
    border: "1px solid",
    borderColor: alpha(accent, 0.22),
    backgroundColor: theme.palette.background.paper,
    color: accent,
    width: { xs: 40, md: 34 },
    height: { xs: 40, md: 34 },
    minWidth: { xs: 40, md: 34 },
    minHeight: { xs: 40, md: 34 },
    p: 0,
    boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.06)}`,
    "&:hover": {
      backgroundColor: alpha(accent, 0.1),
      borderColor: accent,
      transform: "translateY(-1px)",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.05rem",
    },
  };
  const printToolbarIconSx = {
    ...toolbarIconSx,
    color: theme.palette.info.main,
    borderColor: alpha(theme.palette.info.main, 0.45),
    "&:hover": {
      backgroundColor: alpha(theme.palette.info.main, 0.1),
      borderColor: theme.palette.info.main,
      transform: "translateY(-1px)",
    },
  };
  const groupedPrintToolbarIconSx = {
    ...toolbarIconSx,
    color: theme.palette.warning.dark,
    borderColor: alpha(theme.palette.warning.main, 0.45),
    "&:hover": {
      backgroundColor: alpha(theme.palette.warning.main, 0.12),
      borderColor: theme.palette.warning.main,
      transform: "translateY(-1px)",
    },
  };
  const batchOfferToolbarIconSx = {
    ...toolbarIconSx,
    color: "#00a88c",
    borderColor: alpha("#00c2a3", 0.55),
    bgcolor: alpha("#00c2a3", 0.08),
    "&:hover": {
      backgroundColor: alpha("#00c2a3", 0.16),
      borderColor: "#00c2a3",
      transform: "translateY(-1px)",
    },
    "&.Mui-disabled": {
      opacity: 0.45,
    },
  };
  const mobileToolbarSx = {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 0.75,
    p: 1,
    borderRadius: 2.5,
    border: "1px solid",
    borderColor: alpha(accent, 0.18),
    bgcolor: theme.palette.background.paper,
    boxShadow: `0 6px 18px ${alpha(theme.palette.common.black, 0.06)}`,
    "& .MuiIconButton-root": {
      margin: "0 auto",
      width: 40,
      height: 40,
      minWidth: 40,
      minHeight: 40,
    },
    "& > span, & > div": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };
  const gridShellSx = {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    borderRadius: 4,
    border: "1px solid",
    borderColor: alpha(theme.palette.primary.main, 0.08),
    background: `linear-gradient(180deg, ${alpha(
      theme.palette.common.white,
      theme.palette.mode === "dark" ? 0.02 : 0.92,
    )} 0%, ${shellFill} 100%)`,
    boxShadow: `0 22px 48px ${alpha(theme.palette.common.black, 0.08)}`,
    overflow: "hidden",
  };

  const searchFieldSx = {
    ...pageFieldSx(theme),
    width: { xs: "100%", sm: 260, md: 300 },
    minWidth: 0,
    flexShrink: 0,
  };

  const renderPhotoSearchControl = () => (
    <Tooltip
      title={t("EstimatesPage.searchByPhoto", {
        count: photoSearchBudgetNumbers.length,
        defaultValue:
          "Click or drop a product photo to find the estimate — searches all {{count}} budgets, no name needed",
      })}
    >
      <Box
        component="span"
        onDragEnter={handlePhotoSearchDragOver}
        onDragOver={handlePhotoSearchDragOver}
        onDragLeave={handlePhotoSearchDragLeave}
        onDrop={handlePhotoSearchDrop}
        sx={{
          display: "inline-flex",
          borderRadius: "50%",
          outline: photoSearchDragging
            ? `2px dashed ${theme.palette.secondary.main}`
            : "none",
          outlineOffset: 2,
          bgcolor: photoSearchDragging
            ? alpha(theme.palette.secondary.main, 0.14)
            : "transparent",
          transition: "background-color 0.15s ease, outline-color 0.15s ease",
        }}
      >
        <IconButton
          onClick={() => photoSearchInputRef.current?.click()}
          disabled={photoSearchLoading}
          sx={{
            ...toolbarIconSx,
            ...(photoSearchPreview || photoSearchDragging
              ? {
                  borderColor: alpha(theme.palette.secondary.main, 0.45),
                  bgcolor: alpha(theme.palette.secondary.main, 0.08),
                }
              : {}),
          }}
        >
          {photoSearchLoading ? (
            <CircularProgress size={20} />
          ) : (
            <PhotoCameraOutlinedIcon />
          )}
        </IconButton>
      </Box>
    </Tooltip>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        minHeight: "100dvh",
        boxSizing: "border-box",
        overflow: { xs: "auto", md: "hidden" },
        background: pageGradient,
        pt: { xs: 1, md: 1.25 },
        px: { xs: 1.25, sm: 2 },
        pr: { xs: 1.25, sm: 2, md: 3 },
        pb: { xs: 10, md: 2 },
        ...contentMargin,
      }}
    >
      <input
        ref={photoSearchInputRef}
        type="file"
        accept="image/png,image/jpeg,image/webp,image/jpg"
        hidden
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) void handlePhotoSearchFile(file);
        }}
      />
      <Backdrop
        open={photoSearchLoading}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 2,
          flexDirection: "column",
          gap: 2,
          px: 3,
          textAlign: "center",
        }}
      >
        <CircularProgress color="inherit" size={48} />
        <Typography variant="h6" fontWeight={700}>
          {t("EstimatesPage.photoSearchLoadingTitle", {
            defaultValue: "Searching by photo…",
          })}
        </Typography>
        <Typography
          variant="body2"
          sx={{ maxWidth: 420, opacity: 0.92, lineHeight: 1.5 }}
        >
          {t("EstimatesPage.photoSearchLoadingBody", {
            count: photoSearchCandidateCount,
            defaultValue:
              "Comparing {{count}} estimate photos across the full library. You do not need to know the name or code — this may take a few minutes.",
          })}
        </Typography>
      </Backdrop>
      <Box sx={heroShellSx}>
        <Stack
          spacing={{ xs: 1.25, md: 0.875 }}
          sx={{ p: { xs: 1.25, md: 1, lg: 1.25 } }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { md: "center" },
              justifyContent: "space-between",
              gap: { xs: 1.25, md: 1 },
            }}
          >
            <Stack
              direction="row"
              spacing={{ xs: 1.25, md: 1 }}
              alignItems="flex-start"
              sx={{ flex: 1, minWidth: 0 }}
            >
              <Box
                sx={{
                  width: { xs: 44, md: 36 },
                  height: { xs: 44, md: 36 },
                  borderRadius: 2,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: alpha(accent, 0.12),
                  color: theme.palette.primary.dark,
                  border: "1px solid",
                  borderColor: alpha(accent, 0.28),
                }}
              >
                <RequestQuoteOutlinedIcon
                  sx={{ fontSize: { xs: "1.25rem", md: "1.1rem" } }}
                />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  sx={{
                    ...pageSectionTitleSx,
                    fontSize: { xs: "0.68rem", md: "0.62rem" },
                  }}
                >
                  CRM
                </Typography>
                <Typography
                  variant={isMobile ? "h5" : "h6"}
                  component="h1"
                  sx={{ fontWeight: 800, lineHeight: 1.1 }}
                >
                  {t("sidebar.estimates")}
                </Typography>
                {isMobile ? (
                  <Typography
                    sx={{
                      mt: 0.25,
                      color: "text.secondary",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                    }}
                  >
                    Workspace de presupuestos
                  </Typography>
                ) : null}
                <Stack
                  direction="row"
                  spacing={0.75}
                  sx={{ mt: { xs: 0.85, md: 0.5 } }}
                  flexWrap="wrap"
                  useFlexGap
                >
                  {contestacionAvisosCount > 0 ? (
                    <Chip
                      size="small"
                      label={t("EstimatesPage.contestacion.chip", {
                        count: contestacionAvisosCount,
                      })}
                      sx={{
                        ...pageKpiChipSx,
                        bgcolor: "#d32f2f",
                        color: "#fff",
                        fontWeight: 800,
                        border: "1px solid #b71c1c",
                      }}
                    />
                  ) : null}
                  <Chip
                    size="small"
                    label={`Visible ${filteredProyectos.length}`}
                    sx={{
                      ...pageKpiChipSx,
                      bgcolor: alpha(accent, 0.12),
                      color: theme.palette.primary.dark,
                      border: "1px solid",
                      borderColor: alpha(accent, 0.2),
                    }}
                  />
                  <Chip
                    size="small"
                    variant="outlined"
                    label={`Selected ${selectedBudgets.length}`}
                    sx={pageKpiChipSx}
                  />
                  {photoSearchScores &&
                  Object.keys(photoSearchScores).length > 0 ? (
                    <Chip
                      size="small"
                      label={`Photo match ${photoSearchMatchCount}`}
                      onDelete={clearPhotoSearch}
                      sx={{
                        ...pageKpiChipSx,
                        bgcolor: alpha(theme.palette.secondary.main, 0.1),
                        color: theme.palette.secondary.dark,
                        border: "1px solid",
                        borderColor: alpha(theme.palette.secondary.main, 0.24),
                      }}
                    />
                  ) : null}
                </Stack>
              </Box>
            </Stack>

            {!isMobile ? (
              <Stack
                direction="row"
                spacing={0.75}
                useFlexGap
                alignItems="center"
                flexWrap="wrap"
                justifyContent="flex-end"
                sx={{ flexShrink: 0 }}
              >
                <Stack
                  direction="row"
                  spacing={0.5}
                  useFlexGap
                  alignItems="center"
                  flexWrap="wrap"
                >
                  <Tooltip title="Tree grouping order">
                    <ToggleButtonGroup
                      size="small"
                      exclusive
                      value={treeGroupMode}
                      onChange={handleTreeGroupModeChange}
                      sx={{
                        mr: 0.25,
                        "& .MuiToggleButton-root": {
                          px: 1,
                          py: 0.35,
                          textTransform: "none",
                          fontWeight: 700,
                          fontSize: "0.72rem",
                          borderColor: alpha(theme.palette.primary.main, 0.35),
                          color: "primary.main",
                          "&.Mui-selected": {
                            bgcolor: alpha(theme.palette.primary.main, 0.12),
                            color: "primary.dark",
                            borderColor: alpha(
                              theme.palette.primary.main,
                              0.45,
                            ),
                            "&:hover": {
                              bgcolor: alpha(theme.palette.primary.main, 0.18),
                            },
                          },
                        },
                      }}
                    >
                      <ToggleButton
                        value="season"
                        aria-label="Group by season first"
                      >
                        Season
                      </ToggleButton>
                      <ToggleButton
                        value="client"
                        aria-label="Group by client first"
                      >
                        Client
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Tooltip>
                  <Tooltip title={t("EstimatesPage.addEstimate")}>
                    <IconButton
                      onClick={() => setOpenDrawer(true)}
                      sx={toolbarIconSx}
                    >
                      <Add />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("EstimatesPage.resetColumns")}>
                    <IconButton onClick={resetUserColumns} sx={toolbarIconSx}>
                      <RestartAltIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("EstimatesPage.exportExcel")}>
                    <IconButton onClick={exportToExcel} sx={toolbarIconSx}>
                      <Box
                        component="img"
                        src={ExcelIcon}
                        alt="Excel"
                        sx={{ width: 22, height: 22 }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("EstimatesPage.printOne")}>
                    <span>
                      <BudgetPrintSelection
                        idsPresupuestos={selectedBudgets}
                        logoBase64={logoStage}
                        proyectos={proyectos}
                        sx={printToolbarIconSx}
                      />
                    </span>
                  </Tooltip>
                  <Tooltip title={t("EstimatesPage.printGrouped")}>
                    <span>
                      <BudgetPrintSelectionAgrupado
                        idsPresupuestos={selectedBudgets}
                        logoBase64={logoStage}
                        proyectos={proyectos}
                        sx={groupedPrintToolbarIconSx}
                      />
                    </span>
                  </Tooltip>
                  <Tooltip
                    title={
                      batchOfferReady
                        ? isTommyBatchSelection
                          ? `Tommy (TH): marcar Offered sin email (${selectedLeafBudgets.length})`
                          : `Enviar oferta conjunta (${selectedLeafBudgets.length})`
                        : "Selecciona 2–20 presupuestos del mismo cliente"
                    }
                  >
                    <span>
                      <IconButton
                        onClick={openBatchOfferFlow}
                        disabled={!batchOfferReady}
                        sx={batchOfferToolbarIconSx}
                      >
                        <Badge
                          badgeContent={
                            batchOfferReady ? selectedLeafBudgets.length : 0
                          }
                          color="success"
                          overlap="circular"
                          sx={{
                            "& .MuiBadge-badge": {
                              fontSize: "0.65rem",
                              minWidth: 14,
                              height: 14,
                            },
                          }}
                        >
                          <ForwardToInboxOutlinedIcon />
                        </Badge>
                      </IconButton>
                    </span>
                  </Tooltip>
                </Stack>
                <TextField
                  label={t("EstimatesPage.search")}
                  variant="outlined"
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{ ...searchFieldSx, width: { md: 240, lg: 280 } }}
                />
                {renderPhotoSearchControl()}
              </Stack>
            ) : null}
          </Box>

          {isMobile ? (
            <Stack spacing={1.25}>
              <TextField
                label={t("EstimatesPage.search")}
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{ ...searchFieldSx, width: "100%" }}
              />
              {photoSearchScores &&
              Object.keys(photoSearchScores).length > 0 ? (
                <Chip
                  size="small"
                  label={`Photo match ${photoSearchMatchCount}`}
                  onDelete={clearPhotoSearch}
                  sx={{ alignSelf: "flex-start", ...pageKpiChipSx }}
                />
              ) : null}
              <Box sx={mobileToolbarSx}>
                <ToggleButtonGroup
                  size="small"
                  exclusive
                  value={treeGroupMode}
                  onChange={handleTreeGroupModeChange}
                  sx={{
                    "& .MuiToggleButton-root": {
                      px: 1,
                      py: 0.35,
                      textTransform: "none",
                      fontWeight: 700,
                      fontSize: "0.72rem",
                    },
                  }}
                >
                  <ToggleButton value="season">Season</ToggleButton>
                  <ToggleButton value="client">Client</ToggleButton>
                </ToggleButtonGroup>
                {renderPhotoSearchControl()}
                <Tooltip title={t("EstimatesPage.addEstimate")}>
                  <IconButton
                    onClick={() => setOpenDrawer(true)}
                    sx={toolbarIconSx}
                  >
                    <Add />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("EstimatesPage.exportExcel")}>
                  <IconButton onClick={exportToExcel} sx={toolbarIconSx}>
                    <Box
                      component="img"
                      src={ExcelIcon}
                      alt="Excel"
                      sx={{ width: 22, height: 22 }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("EstimatesPage.printOne")}>
                  <span>
                    <BudgetPrintSelection
                      idsPresupuestos={selectedBudgets}
                      logoBase64={logoStage}
                      proyectos={proyectos}
                      sx={printToolbarIconSx}
                    />
                  </span>
                </Tooltip>
                <Tooltip title={t("EstimatesPage.printGrouped")}>
                  <span>
                    <BudgetPrintSelectionAgrupado
                      idsPresupuestos={selectedBudgets}
                      logoBase64={logoStage}
                      proyectos={proyectos}
                      sx={groupedPrintToolbarIconSx}
                    />
                  </span>
                </Tooltip>
                <Tooltip
                  title={
                    batchOfferReady
                      ? isTommyBatchSelection
                        ? `Tommy (TH): Offered sin email (${selectedLeafBudgets.length})`
                        : `Oferta conjunta (${selectedLeafBudgets.length})`
                      : "Selecciona 2–20 del mismo cliente"
                  }
                >
                  <span>
                    <IconButton
                      onClick={openBatchOfferFlow}
                      disabled={!batchOfferReady}
                      sx={batchOfferToolbarIconSx}
                    >
                      <ForwardToInboxOutlinedIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
            </Stack>
          ) : null}

          {!canCreate && openDrawer && missingKeys.length > 0 ? (
            <Box sx={{ color: "error.main", fontSize: "0.85rem" }}>
              Faltan: {missingKeys.join(", ")}
            </Box>
          ) : null}
        </Stack>
      </Box>

      {isMobile ? (
        <Stack spacing={2} sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
          {Object.keys(mobileBudgetsByGroup).length === 0 ? (
            <Box
              sx={{
                py: 5,
                px: 2,
                textAlign: "center",
                borderRadius: 3,
                border: "1px dashed",
                borderColor: "divider",
                bgcolor: alpha(theme.palette.background.paper, 0.7),
              }}
            >
              <Typography color="text.secondary" fontWeight={600}>
                No hay presupuestos con la búsqueda actual
              </Typography>
            </Box>
          ) : (
            Object.entries(mobileBudgetsByGroup).map(([groupName, budgets]) => (
              <Box key={groupName}>
                <Typography sx={{ ...pageSectionTitleSx, mb: 1, px: 0.5 }}>
                  {groupName}
                </Typography>
                <Stack spacing={1.25}>
                  {budgets.map((budget) => renderMobileBudgetCard(budget))}
                </Stack>
              </Box>
            ))
          )}
        </Stack>
      ) : (
        <Box
          sx={{
            ...pageContentCardSx(theme, accent),
            p: 0,
            overflow: "hidden",
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1.15,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              borderBottom: "1px solid",
              borderColor: alpha(theme.palette.divider, 0.75),
              bgcolor: alpha(theme.palette.primary.main, 0.03),
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
              {filteredProyectos.length} presupuestos
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontWeight: 600 }}
            >
              Árbol por temporada · clic en hoja para editar
              {photoSearchScores && Object.keys(photoSearchScores).length > 0
                ? " · ordenado por similitud de foto"
                : ""}
            </Typography>
          </Box>
          <Box
            sx={{
              ...gridShellSx,
              border: "none",
              borderRadius: 0,
              boxShadow: "none",
            }}
          >
            <DataGridPro
              apiRef={apiRef}
              rows={filteredProyectos}
              columns={columns}
              /* VISIVIIDAD CHECKBOX */
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(model) =>
                setColumnVisibilityModel(model)
              }
              /* VISIVIIDAD CHECKBOX */
              treeData
              checkboxSelection
              isRowSelectable={isBudgetLeafGridRow}
              isGroupExpandedByDefault={isGroupExpandedByDefault}
              onRowSelectionModelChange={(ids) => {
                // Solo hojas reales (IdPresupuesto); ignora filas de agrupación del árbol
                const leafIds = (Array.isArray(ids) ? ids : []).filter((id) => {
                  const s = String(id ?? "");
                  if (s.startsWith("auto-generated-row-")) return false;
                  return (proyectos || []).some(
                    (p) => String(p.IdPresupuesto) === s,
                  );
                });
                setSelectedBudgets(leafIds);
              }}
              getTreeDataPath={(row) =>
                getEstimateTreeDataPath(row, treeGroupMode)
              }
              groupingColDef={{
                headerName: getEstimateTreeGroupHeader(treeGroupMode),
                width: 420,
                renderCell: (params) => {
                  const { rowNode, id } = params;
                  const raw = String(
                    params.formattedValue ?? params.value ?? "",
                  );
                  const clean = raw.replace(/\s\(\d+\)$/, "");
                  const depth = rowNode?.depth ?? 0;
                  const indentPx = depth * 16;
                  const hasChildren =
                    Array.isArray(rowNode?.children) &&
                    rowNode.children.length > 0;
                  const isLeaf = !hasChildren;
                  const displayLabel = isLeaf
                    ? clean.replace(/\s+—\s+\d+$/, "")
                    : clean;
                  const labelChipSx = isLeaf
                    ? designChipSx(params.row?.colorGroup, theme)
                    : treeGroupChipSx(depth, theme, alpha, displayLabel);

                  const toggle = async (e) => {
                    e.stopPropagation();
                    const next = !rowNode.childrenExpanded;

                    apiRef.current?.setRowChildrenExpansion(id, next);
                    setExpandedIds((prev) => {
                      const copy = new Set(prev);
                      if (next) copy.add(id);
                      else copy.delete(id);
                      return copy;
                    });

                    if (next) {
                      const label = params.formattedValue || params.value;
                      if (label) {
                        await fetchBudgetImagesForGroup(label);
                      }
                    }
                  };

                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        minWidth: 0,
                        width: "100%",
                        height: "100%",
                        pl: `${indentPx}px`,
                        pr: 1,
                      }}
                    >
                      {hasChildren ? (
                        <IconButton
                          size="small"
                          onClick={toggle}
                          tabIndex={-1}
                          aria-label={
                            rowNode.childrenExpanded
                              ? "hide children"
                              : "show children"
                          }
                          sx={{
                            border: "1px solid",
                            borderColor: alpha(theme.palette.primary.main, 0.1),
                            backgroundColor: alpha(
                              theme.palette.common.white,
                              0.72,
                            ),
                            boxShadow: `0 6px 16px ${alpha(theme.palette.common.black, 0.04)}`,
                          }}
                        >
                          {rowNode.childrenExpanded ? (
                            <ExpandMore />
                          ) : (
                            <ChevronRight />
                          )}
                        </IconButton>
                      ) : (
                        <span style={{ width: 28, display: "inline-block" }} />
                      )}
                      <Chip
                        size="small"
                        label={displayLabel}
                        title={displayLabel}
                        sx={labelChipSx}
                      />
                    </Box>
                  );
                },
              }}
              defaultGroupingExpansionDepth={0}
              disableRowSelectionOnClick
              onCellClick={(params, event) => {
                if (params.field === "Foto") {
                  event.defaultMuiPrevented = true;
                  return;
                }
                if (params.field === "__tree_data_group__") {
                  event.defaultMuiPrevented = true;
                  if (isBudgetLeafGridRow(params)) {
                    handleRowClick(params);
                  }
                }
              }}
              onRowClick={(params, event) => {
                if (event?.target?.closest?.("[data-article-thumb]")) {
                  event.defaultMuiPrevented = true;
                  return;
                }
                if (!isBudgetLeafGridRow(params)) {
                  event.defaultMuiPrevented = true;
                  return;
                }
                handleRowClick(params);
              }}
              getRowClassName={(p) =>
                p.id === selectedId ? "selected-row" : ""
              }
              components={{ Toolbar: GridToolbar }}
              initialState={{
                pagination: { paginationModel: { pageSize: 50 } },
              }}
              pageSizeOptions={[10, 20, 50]}
              pagination
              getRowId={(row) => row.id}
              sx={{
                cursor: "pointer",
                flex: 1,
                minHeight: 0,
                height: "100%",
                border: "none",
                borderRadius: 0,
                overflow: "hidden",
                backgroundColor: "transparent",
                "& .MuiDataGrid-main": {
                  backgroundColor: "transparent",
                },
                "& .MuiDataGrid-toolbarContainer": {
                  px: 1.5,
                  py: 1.15,
                  borderBottom: "1px solid",
                  borderBottomColor: alpha(theme.palette.divider, 0.5),
                  background: `linear-gradient(180deg, ${alpha(
                    theme.palette.common.white,
                    0.82,
                  )} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
                  backdropFilter: "blur(10px)",
                  gap: 0.75,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButtonBase-root": {
                  borderRadius: 999,
                  textTransform: "none",
                  fontWeight: 700,
                },

                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: 700,
                  fontSize: "0.78rem",
                  letterSpacing: "0.01em",
                },
                "& .MuiDataGrid-cell": {
                  borderBottomColor:
                    theme.palette.mode === "dark"
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(15,23,42,0.06)",
                },

                "& .MuiDataGrid-row": {
                  backgroundColor: alpha(theme.palette.background.paper, 0.72),
                  transition:
                    "background-color 120ms ease-in-out, transform 120ms ease-in-out",
                },
                "& .MuiDataGrid-row:hover, & .MuiDataGrid-row:hover > .MuiDataGrid-cell":
                  {
                    backgroundColor:
                      theme.palette.mode === "dark"
                        ? "rgba(144,178,183,0.14)"
                        : "rgba(144,178,183,0.18)",
                  },

                "& .MuiDataGrid-row.selected-row, & .MuiDataGrid-row.selected-row > .MuiDataGrid-cell":
                  {
                    backgroundColor:
                      theme.palette.mode === "dark" ? "#2c2c2c" : "#d0e0e3",
                  },
                "& .MuiDataGrid-row.selected-row:hover, & .MuiDataGrid-row.selected-row:hover > .MuiDataGrid-cell":
                  {
                    backgroundColor:
                      theme.palette.mode === "dark" ? "#3a3a3a" : "#c0d5d9",
                  },

                // Ocultar contador "(n)" que añade MUI a los nodos
                '& .MuiDataGrid-cell[data-field="__tree_data_group__"] .MuiDataGrid-treeDataGroupingCell-count':
                  {
                    display: "none !important",
                  },
                '& .MuiDataGrid-cell[data-field="__row_group_by_columns_group__"] .MuiDataGrid-groupingCriteriaCell-count':
                  {
                    display: "none !important",
                  },

                // Checkbox solo en presupuestos (hojas): ocultar en filas de agrupación
                '& .MuiDataGrid-row[data-id^="auto-generated-row-"] .MuiDataGrid-cellCheckbox':
                  {
                    visibility: "hidden",
                    pointerEvents: "none",
                  },
                "& .MuiDataGrid-cellCheckbox .MuiCheckbox-root.Mui-disabled": {
                  visibility: "hidden",
                  pointerEvents: "none",
                },

                /* --- tus estilos existentes --- */
                "& .group-row": {
                  backgroundColor:
                    theme.palette.mode === "dark" ? "#000000" : "#e0e9ec",
                },
                "& .MuiDataGrid-columnHeaders": {
                  background: `linear-gradient(180deg, ${alpha(
                    theme.palette.primary.main,
                    0.05,
                  )} 0%, ${alpha(theme.palette.common.white, 0.94)} 100%)`,
                  borderBottom: "1px solid",
                  borderBottomColor:
                    theme.palette.mode === "dark"
                      ? "rgba(255,255,255,0.12)"
                      : "rgba(15,23,42,0.08)",
                  backdropFilter: "blur(8px)",
                  "& .MuiDataGrid-columnHeader[data-field='ProyectoNombre']": {
                    display: "none",
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "1px solid",
                  borderTopColor: alpha(theme.palette.divider, 0.5),
                  backgroundColor: alpha(theme.palette.common.white, 0.68),
                  backdropFilter: "blur(8px)",
                },
                "& .normal-row .MuiDataGrid-cell[data-field='ProyectoNombre']":
                  {
                    display: "none",
                  },
                "& .grouped-cell": {
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  fontSize: "1.3em",
                  minWidth: "320px",
                  maxWidth: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  flex: 1,
                },
              }}
            />
          </Box>
        </Box>
      )}

      <NewBudgetDrawer
        open={openDrawer}
        onClose={handleDrawerClose}
        onBudgetAdded={handleBudgetAdded}
        budget={selectedBudget}
        escandalloGrupos={escandalloGrupos}
        escandalloSubgrupos={escandalloSubgrupos}
        existingLines={linesForSelectedBudget}
        onValidate={handleValidate}
        createRef={createBudgetRef}
      />

      <EstimateEnviarOfertaConjuntaDialog
        open={batchOfferOpen}
        onClose={() => setBatchOfferOpen(false)}
        presupuestos={selectedLeafBudgets}
        onSent={() => {
          setSelectedBudgets([]);
          fetchBudgets(incoterms);
        }}
      />

      <EstimateTommyOfferedDialog
        open={tommyBatchOpen}
        onClose={() => {
          if (!tommyBatchConfirming) setTommyBatchOpen(false);
        }}
        confirming={tommyBatchConfirming}
        count={
          selectedLeafBudgets.filter(
            (p) => String(p.Estado || "") === "Created",
          ).length || selectedLeafBudgets.length
        }
        alreadyOffered={
          selectedLeafBudgets.length > 0 &&
          selectedLeafBudgets.every((p) => String(p.Estado || "") !== "Created")
        }
        onConfirm={confirmTommyBatchOffered}
      />
    </Box>
  );
};

export default Estimates;
